{
  "Common": {
    "Youtopia": "Youtopia",
    "Invalid_Phone_Number": "Please enter a valid phone number.",
    "Continue": "Continue",
    "Other": "Other",
    "Dismiss": "Dismiss",
    "Retry": "Try Again",
    "Required": "Required",
    "Add": "Add",
    "Remove": "Remove",
    "Update": "Update",
    "Close": "Close",
    "Cancel": "Cancel",
    "Ok": "Ok",
    "Save": "Save",
    "Saving": "Saving...",
    "Loading": "Loading",
    "Try_Again": "Try Again",
    "Profile_Updated": "Your profile was updated",
    "Send": "Send",
    "Yes": "Yes",
    "No": "No",
    "Me": "Me",
    "You": "You",
    "Low": "Low",
    "Panic": "Panic",
    "Optimal": "Optimal",
    "FDA_Disclaimer": "These statements have not been evaluated by the FDA. These consumables are not intended to diagnose, treat, cure, or prevent any disease.",
    "Search": "Search",
    "Now": "Now",
    "Delete": "Delete",
    "View_Detail": "View Detail",
    "Back": "Back",
    "Next": "Next",
    "Recommended": "Recommended",
    "Size": "Size",
    "Something_Went_Wrong": "Something Went Wrong",
    "Success": "Success",
    "No_Results": "No Results",
    "Skip": "Skip",
    "Increment": "Increase",
    "Decrement": "Decrease",
    "Clear_All": "Clear All",
    "Apply": "Apply",
    "Go_Back": "Go Back",
    "Reset": "Reset",
    "Edit": "Edit",
    "Got_It": "Got It",
    "More": "More"
  },
  "Splash": {
    "Title_1": "Get and Stay Healthy",
    "Title_2": "the Easy Way."
  },
  "Auth": {
    "Quote": "The <b>FOOD</b> you eat can be either the safest and most powerful form of <b>MEDICINE</b> or the slowest form of <b>POISON</b>.",
    "Author": "– Ann Wigmore",
    "Welcome": "Welcome to the revolutionary new world of precision nourishment automation. Now your food can be your medicine and you can enter into a perpetual wellness cycle of vibrant health and longevity.",
    "Start_Your_Journey": "Start Your Journey",
    "Learn_More_About_Youtopia": "Learn More About Youtopia",
    "Email": "Email",
    "Email_Address": "Email Address",
    "Password": "Password",
    "Already_Have_Account": "Already have an account?",
    "Log_In": "Log In",
    "Sign_Up": "Sign Up",
    "Dont_Have_An_Account": "Don't Have An Account?",
    "Register": "Register",
    "Failed_To_Authenticate": "Failed To Authenticate",
    "Failed_To_Logout": "Failed To Logout",
    "Failed_To_Load_Profile": "Failed To Load Your Profile",
    "Account_Setup_In_Progress": "We're still setting up your account. Please sign in again.",
    "Discover_Youtopia": "Discover Youtopia",
    "Enable_Biometrics": "Enable Biometrics",
    "Local_Sign_In_Header": "Local Sign In",
    "Local_Sign_In_Message": "Sign in as an identity this local stack has provisioned, by its email or external id.",
    "Local_Sign_In_Placeholder": "Email or external id",
    "Local_Sign_In_Unknown_Identity": "This local stack holds no identity for {{identity}}. Provision one with app-host/provision-local-user.sh in Youtopia.LocalDev."
  },
  "Invite": {
    "Invitation": "Invitation",
    "Welcome_To_Youtopia": "Welcome to Youtopia",
    "Invited_You": "Invited you!",
    "You_Have_Been_Invited": "You've been invited!",
    "Join_Household_Description": "Join {{name}}'s household and start getting and staying healthy the easy way!",
    "Learn_More_About_Youtopia": "Learn More About Youtopia",
    "Already_Have_Account": "Already have an account?",
    "Log_In": "Log In",
    "No_Longer_Available_Title": "Invitation No Longer Available",
    "No_Longer_Available_Description": "This invitation has expired or is no longer valid.",
    "Request_New_Invite": "Please contact the person who invited you to request a new invitation.",
    "Accept_Invite": "Accept Invite",
    "Reject_Invite": "Reject Invite",
    "Close": "Close"
  },
  "Accept_Invitation": {
    "Reject": "Reject",
    "Create_Profile_Title": "Create your profile",
    "Create_Profile_Description": "Create an account so we can remember your goals and keep everything in sync.",
    "How_It_Works_Button": "How It Works"
  },
  "Agreements": {
    "Modal_Title": "Membership Agreements",
    "Welcome_To_Youtopia": "Welcome to Youtopia",
    "Built_On_Trust": "Built on trust and care",
    "Built_On_Trust_Description": "These agreements help protect you and the people on your account.",
    "Read_Agreement": "Read Agreement",
    "Read_And_Accept": "Read and Accept",
    "Review_Agreement": "Review Agreement",
    "I_Have_Read_And_Agree": "I have read and agree to the {{agreement}}",
    "Agree_And_Continue": "Agree and Continue",
    "Terms_Title": "Terms of Service",
    "Terms_Description": "By using Youtopia, users agree to the platform's rules, payment terms, and legal conditions, including arbitration and limits on Youtopia's liability. The services are positioned as wellness tools rather than medical care, and users are responsible for their own health decisions, account activity, and compliance with the terms.",
    "Terms_Content": "Terms of Service\n\nLast Updated: January 1, 2025\n\nWelcome to Youtopia. By accessing or using our services, you agree to be bound by these Terms of Service.\n\n1. Acceptance of Terms\nBy using Youtopia, you agree to these terms and our Privacy Policy. If you do not agree, please do not use our services.\n\n2. Service Description\nYoutopia provides wellness-focused nutrition and health optimization services. Our services are not medical care and should not replace professional medical advice.\n\n3. User Responsibilities\nYou are responsible for:\n- Providing accurate information\n- Maintaining account security\n- Your health decisions\n- Compliance with these terms\n\n4. Payment Terms\nSubscription fees are billed according to your selected plan. Refunds are handled per our refund policy.\n\n5. Limitation of Liability\nYoutopia is not liable for health outcomes. You assume responsibility for decisions made using our services.\n\n6. Dispute Resolution\nDisputes will be resolved through binding arbitration.\n\n7. Changes to Terms\nWe may update these terms. Continued use constitutes acceptance of changes.",
    "Privacy_Title": "Privacy Policy",
    "Privacy_Description": "Youtopia collects personal, behavioral, and health-related information to provide personalized wellness experiences, improve services, and fulfill orders. Your data is protected with strong security measures, used primarily to deliver and improve the service, and you have rights to access, correct, or delete your information.",
    "Privacy_Content": "Privacy Policy\n\nLast Updated: January 1, 2025\n\nYour privacy is important to us. This policy explains how we collect, use, and protect your information.\n\n1. Information We Collect\n- Personal information (name, email, date of birth)\n- Health and wellness data\n- Dietary preferences and restrictions\n- Usage and behavioral data\n\n2. How We Use Your Information\n- Personalize your wellness experience\n- Calculate your Nutrient Score\n- Fulfill orders and provide services\n- Improve our platform\n- Communicate with you\n\n3. Data Protection\nWe use industry-standard security measures to protect your data, including encryption and secure servers.\n\n4. Data Sharing\nWe do not sell your data. We may share data with:\n- Service providers who assist our operations\n- As required by law\n\n5. Your Rights\nYou have the right to:\n- Access your data\n- Correct inaccuracies\n- Delete your data\n- Export your data\n\n6. Contact Us\nFor privacy questions, contact privacy@youtopia.com",
    "Discovery_Title": "Discovery Center Notice, Consent & Waiver",
    "Discovery_Description": "At our Discovery Center experiences, Youtopia may collect health information such as assessments or lab results to personalize your Nutrient Score and wellness experience. These services are wellness-focused (not medical care), and by participating you consent to data collection and accept responsibility for how you use the results.",
    "Discovery_Content": "Discovery Center Notice, Consent & Waiver\n\nLast Updated: January 1, 2025\n\nThis notice applies to services provided at Youtopia Discovery Centers.\n\n1. Services Provided\nAt our Discovery Centers, we may:\n- Conduct health assessments\n- Collect lab samples for analysis\n- Provide personalized wellness consultations\n- Demonstrate Youtopia products and services\n\n2. Wellness Focus\nOur services are wellness-focused and are NOT medical care. We do not diagnose, treat, or cure medical conditions. Always consult healthcare providers for medical concerns.\n\n3. Data Collection Consent\nBy participating, you consent to:\n- Collection of health assessment data\n- Lab sample collection and analysis\n- Use of results to personalize your Youtopia experience\n- Storage of data per our Privacy Policy\n\n4. Assumption of Responsibility\nYou acknowledge that:\n- Results are for wellness purposes only\n- You are responsible for how you use the information\n- Youtopia is not liable for health decisions\n\n5. Waiver\nYou waive claims against Youtopia for outcomes related to Discovery Center services, except in cases of gross negligence.",
    "Guardian_Title": "Guardian agreement for {{name}}",
    "Guardian_Description": "As the legal guardian, you are agreeing to the terms of service, privacy policy, and discovery center consent on behalf of your dependent.",
    "Guardian_Content": "Guardian Agreement\n\nLast Updated: January 1, 2025\n\nAs the legal guardian of the named dependent, you acknowledge and agree to the following:\n\n1. Consent\nYou consent to the collection and use of your dependent's personal and health-related information by Youtopia for the purpose of providing wellness services.\n\n2. Responsibility\nYou accept responsibility for:\n- Your dependent's use of Youtopia services\n- Decisions made based on wellness information provided\n- Ensuring your dependent's account activity complies with our terms\n\n3. Data Collection\nYou consent to the collection of your dependent's:\n- Personal information (name, date of birth)\n- Health and wellness data\n- Dietary preferences and restrictions\n\n4. Wellness Focus\nYou understand that Youtopia's services are wellness-focused and are not medical care. You will consult healthcare providers for any medical concerns regarding your dependent.\n\n5. Guardian Authority\nYou confirm that you have the legal authority to consent on behalf of the named dependent and that all information provided is accurate.",
    "Invitation_Accept_Error": "We couldn't finish accepting your invitation. Please try again.",
    "Invitation_Accept_Household_Not_Settled": "You can't join this household until your own is settled. A household has to be empty and have no active memberships before you can leave it. Remove any other members and cancel any memberships, then try again.",
    "Invitation_Accept_Try_Again": "Something was already updating your household. Please try again.",
    "Invitation_Accept_Household_Has_Members": "You can't join this household while other people are still in yours. Remove them from your household, then try again.",
    "Invitation_Accept_Household_Has_Memberships": "You can't join this household while your own still has an active membership. Cancel it, then try again.",
    "Invitation_Accept_Household_Needs_Support": "We couldn't move you into this household. Please contact support so we can sort it out for you."
  },
  "Health_Sharing": {
    "Title": "Health data sharing",
    "Choose_Title": "Share your health data",
    "Choose_Description": "Choose which of your guardians can see your health and nutrition information. You decide for each guardian individually.",
    "Share_With": "Share my health data with {{name}}",
    "Change_Later": "You can change this for any guardian at any time from your profile.",
    "Save": "Save preferences",
    "Skip": "Skip for now",
    "Not_Now": "Not now",
    "Saved_Title": "Preferences saved",
    "Saved_Description": "Your health sharing choices have been updated."
  },
  "Settings": {
    "Title": "Settings",
    "Household": "Household",
    "Manage_Household": "Manage Household",
    "Nutrient_Profiles": "Nutrient Profiles",
    "Health_Profiles": "Health Profiles",
    "Payment_Information": "Payment Information",
    "Address_Book": "Address Book",
    "Orders_And_Purchase_History": "Orders & Purchase History",
    "Notifications": "Notifications",
    "Notifications_Enabled": "Notifications Enabled",
    "Notifications_Not_Available": "Notifications Not Available",
    "Notifications_Permission": "Notifications Permission",
    "Notifications_Warning": "You have not allowed Youtopia to receive notifications. It greatly improves Youtopia features.",
    "Notifications_Blocked_Instructions": "Notifications are blocked for this site. Update your browser's site settings to receive them.",
    "Web_Push_Banner_Title": "Enable Notifications",
    "Web_Push_Banner_Message": "Get order updates and important alerts in your browser.",
    "Web_Push_Banner_Enable": "Enable",
    "Dismiss_All_Notifications": "Dismiss All Notifications",
    "Mark_All_As_Read": "Mark all as read",
    "No_Notifications": "No Notifications",
    "Settings": "Settings",
    "My_Profile": "My Profile",
    "App_Settings": "App Settings",
    "General": "General",
    "Help": "Help",
    "Sign_Out": "Sign Out",
    "Security_And_Biometrics": "Security and Biometrics",
    "Biometrics": "Biometrics",
    "Biometrics_Enabled": "Biometrics Enabled",
    "Biometrics_Not_Available": "Biometrics Not Available"
  },
  "Notification_Preferences": {
    "Categories": {
      "Orders": "Orders",
      "Health": "Health",
      "Announcements": "Announcements",
      "Promotions": "Promotions"
    },
    "Channels": {
      "Push": "Push",
      "SMS": "SMS",
      "Email": "Email",
      "InApp": "In-App"
    },
    "On": "On",
    "All_Off": "All notifications off"
  },
  "NotificationService": {
    "Get_Notifications_Error": "Failed to load notifications",
    "Mark_Notification_Read_Error": "Failed to mark notification as read",
    "Mark_Notifications_Read_Error": "Failed to mark notifications as read"
  },
  "Health_Profile": {
    "Title": "Health Profile",
    "My_Health_Profile": "My Health Profile",
    "My_Health_Profile_Description": "Your background information helps us evaluate your current health and understand your specific biological needs."
  },
  "Health_History": {
    "About_You": {
      "Title": "About You",
      "Description": "Please share some basic information about yourself."
    },
    "Lifestyle": {
      "Title": "Lifestyle",
      "Description": "Please share some information regarding your lifestyle."
    },
    "Disease_Recognition": {
      "Title": "Disease Recognition",
      "Description": "Please share if any conditions have impacted your life.",
      "Page_Description": "Please indicate if you’ve previously had or are currently diagnosed with any of the following conditions (select all that apply):"
    },
    "Health_Concerns": {
      "Title": "Health Concerns",
      "Description": "Please share any concerns you have with your current health.",
      "Page_Description": "Indicate on a scale from 1 to 5 (with 5 being the most) how concerned you are, your family, or your health care provider about the following as it relates to you:"
    },
    "Allergies_Intolerances": {
      "Title": "Allergies & Intolerances",
      "Description": "Please share information about your allergies and intolerances."
    },
    "Medications_Supplements": {
      "Title": "Current Medications & Supplements",
      "Description": "Please share any medications or supplements you take or are being treated with."
    },
    "Birthday": {
      "Label": "When is your birthday?"
    },
    "Genetic_Sex": {
      "Label": "What is your genetic sex at birth?",
      "Male": "Male",
      "Female": "Female"
    },
    "Pregnant_Lactating": {
      "Label": "Are you currently pregnant, lactating or neither?",
      "Pregnant": "Pregnant",
      "Lactating": "Lactating",
      "Neither": "Neither"
    },
    "Height": {
      "Label": "What is your height?",
      "Select_Height": "Select Height",
      "Feet_And_Inches": "{{val1}}' {{val2}}\""
    },
    "Weight": {
      "Label": "What is your weight today?",
      "Enter_Weight": "Enter Weight in Lbs"
    },
    "Waist_Circumference": {
      "Label": "When shopping for jeans, what’s your typical waist size?",
      "Select_Waist_Size": "Select Waist Size",
      "Kids_Size": "Kids - {{val1}}",
      "Mens_Size": "{{val1}}",
      "Womens_Size": "{{val1}} / {{val2}} (in.)"
    },
    "Daily_Activity_Level": {
      "Label": "What’s your typical level of daily activity?",
      "Select_Activity_Level": "Select Activity Level",
      "Little_To_No_Activity": "Little To No Activity",
      "Lightly_Active": "Lightly Active",
      "Moderately_Active": "Moderately Active",
      "Very_Active": "Very Active",
      "Intense_Activity": "Intense Activity"
    },
    "Satisfied_With_Weight": {
      "Label": "Are you satisfied with your current weight?"
    },
    "Ethnicity": {
      "Label": "What is your ethnicity?",
      "Select_Ethnicity": "Select Ethnicity",
      "American_Indian_Or_Alaska_Native": "American Indian or Alaska Native",
      "Asian": "Asian",
      "Black_Or_African_American": "Black or African American",
      "Hispanic_Or_Latino": "Hispanic or Latino",
      "Native_Hawaiian_Or_Other_Pacific_Islander": "Native Hawaiian or Other Pacific Islander",
      "White": "White"
    },
    "Felt_Energy_Level": {
      "Label": "Energy Level",
      "Low_Value_Label": "Incapacitating Fatigue",
      "High_Value_Label": "Great Energy & Vitality"
    },
    "Felt_Pain": {
      "Label": "Pain",
      "Low_Value_Label": "Severe Pain",
      "High_Value_Label": "Pain Free"
    },
    "Felt_Happiness": {
      "Label": "Happiness",
      "Low_Value_Label": "Profound Depression",
      "High_Value_Label": "Joy & Happiness"
    },
    "Felt_Thinking": {
      "Label": "Thinking",
      "Low_Value_Label": "Distractible & Scattered",
      "High_Value_Label": "Focused Thought"
    },
    "Felt_Contentment": {
      "Label": "Contentment",
      "Low_Value_Label": "Anxious & Discontented",
      "High_Value_Label": "Deep Peace & Contentment"
    },
    "Felt_Memory": {
      "Label": "Memory",
      "Low_Value_Label": "Poor Memory or \"Brain-Fog\"",
      "High_Value_Label": "Sharp Memory & Concentration"
    },
    "Felt_Eating": {
      "Label": "Eating",
      "Low_Value_Label": "Hungry After Eating",
      "High_Value_Label": "Satisfied After Eating"
    },
    "Felt_Sleep": {
      "Label": "Sleep",
      "Low_Value_Label": "Horrible Sleep",
      "High_Value_Label": "Sleep Well & Rested"
    },
    "Felt_Body_Shape": {
      "Label": "Body Shape",
      "Low_Value_Label": "My Body Shape is Unhealthy",
      "High_Value_Label": "My Body Shape is Healthy"
    },
    "Felt_Tummy": {
      "Label": "Tummy",
      "Low_Value_Label": "Bloated, Gassy, Painful Tummy",
      "High_Value_Label": "My Tummy is Happy"
    },
    "Felt_Bowel_Movement": {
      "Label": "Bowel Movement",
      "Low_Value_Label": "Diarrhea &/or Constipation",
      "High_Value_Label": "Good Pooping"
    },
    "Felt_Purpose": {
      "Label": "Purpose",
      "Low_Value_Label": "Feeling Lost",
      "High_Value_Label": "Living with Purpose"
    },
    "Felt_Self_Care": {
      "Label": "Self Care",
      "Low_Value_Label": "No Time Given for Self-Care",
      "High_Value_Label": "Giving Time for Self-Care"
    },
    "Felt_Relationships": {
      "Label": "Relationships",
      "Low_Value_Label": "Isolated and Alone",
      "High_Value_Label": "Healthy Social & Intimate Relationships"
    },
    "Felt_Spiritually": {
      "Label": "Spirituality",
      "Low_Value_Label": "Spiritually Disconnected",
      "High_Value_Label": "Spiritually Connected"
    },
    "Felt_Motivation": {
      "Label": "Motivation",
      "Low_Value_Label": "Feeling Stuck",
      "High_Value_Label": "Highly Motivated"
    },
    "Physical_Activity_Time_Spent": {
      "Label": "What is the amount of time you spend doing physcial activity?",
      "Select_Amount_Of_Time": "Select Amount of Time",
      "None": "None",
      "Light": "20-30 minutes 1 to 3 days a week",
      "Moderate": "20-30 minutes 4 to 5 days a week",
      "Heavy": "20-30 minutes 6 to 7 days a week",
      "Intense": "2 or more times per day of intense exercise"
    },
    "Physical_Activity_Type": {
      "Label": "What type of physical activity do you do?",
      "Select_Activities": "Select Activities",
      "Hiking": "Hiking/Rucking",
      "Weight_Lifting": "Weight Lifting",
      "Cycling": "Cycling",
      "Walking": "Walking",
      "Running": "Running",
      "Sports": "Sports",
      "Skiing": "Skiing",
      "Dancing": "Dancing",
      "Swimming": "Swimming",
      "Gymnastics": "Gymnastics",
      "Manual_Labor": "Manual Labor",
      "Yoga": "Yoga/Pilates",
      "Other": "Other Activities"
    },
    "Hours_Of_Sleep": {
      "Label": "How many hours of sleep do you typically get each night?"
    },
    "Glasses_Of_Water": {
      "Label": "How many 8 oz. glasses of water do you typically drink in a day?"
    },
    "Stress_Work": {
      "Label": "Work Stress"
    },
    "Stress_Family": {
      "Label": "Family Stress"
    },
    "Stress_Social": {
      "Label": "Social Stress"
    },
    "Stress_Financial": {
      "Label": "Financial Stress"
    },
    "Stress_Health": {
      "Label": "Health Stress"
    },
    "Stress_Other": {
      "Label": "Stress From Other Sources"
    },
    "Eat_Out": {
      "Label": "How many times do you eat out each week?",
      "Zero_To_One": "0-1",
      "Two_To_Three": "2-3",
      "Four_To_Five": "4-5",
      "Six_To_Seven": "6-7",
      "Eight_Plus": "8+"
    },
    "Diet_Is_Healthy": {
      "Label": "My current diet is very healthy"
    },
    "Eat_Breakfast": {
      "Label": "I eat breakfast every morning"
    },
    "Eat_Healthy_Snacks": {
      "Label": "I only eat healthy snacks"
    },
    "Never_Eat_Late": {
      "Label": "I never eat past 8:00 PM"
    },
    "Adopt_Healthier_Lifestyle": {
      "Label": "I’m likely to adopt a healthier lifestyle"
    },
    "Stress_Impact_Appetite": {
      "Label": "What impact does stress have on your appetite?",
      "Increased": "Increased",
      "Not_Affected": "Not Affected",
      "Decreased": "Decreased"
    },
    "Food_Cravings": {
      "Label": "Do you crave specific foods?"
    },
    "Feel_Energized": {
      "Label": "When do you feel most energized?",
      "Morning": "Morning",
      "Midday": "Midday",
      "Evening": "Evening"
    },
    "Sugary_Drinks": {
      "Label": "How many 12oz or greater sugary drinks, diet sodas, or similar do you consume per day?",
      "Zero": "0",
      "One_To_Two": "1-2",
      "Three_To_Five": "3-5",
      "Six_To_Nine": "6-9",
      "Ten_Plus": "10+"
    },
    "Alcohol_Use": {
      "Label": "How many alcoholic beverages do you drink each week?",
      "Zero": "0",
      "One_To_Two": "1-2",
      "Three_To_Five": "3-5",
      "Six_To_Nine": "6-9",
      "Ten_Plus": "10+"
    },
    "Tobacco_Use": {
      "Label": "Do you use tobacco?"
    },
    "Drug_Use": {
      "Label": "Do you use any stimulants or recreational drugs?"
    },
    "Toxin_Concern": {
      "Label": "How concerned are you with toxins entering your body?",
      "None": "None",
      "Somewhat": "Somewhat",
      "Very": "Very"
    },
    "Health_Concern_Physical_Activity": {
      "Label": "Physical Activity"
    },
    "Health_Concern_Nutrition": {
      "Label": "Nutrition"
    },
    "Health_Concern_Overweight": {
      "Label": "Overweight / Obesity"
    },
    "Health_Concern_Tobacco": {
      "Label": "Tobacco"
    },
    "Health_Concern_Substance_Abuse": {
      "Label": "Substance Abuse"
    },
    "Health_Concern_Mental_Health": {
      "Label": "Physical Activity"
    },
    "Health_Concern_Injury_Violence": {
      "Label": "Injury and Violence"
    },
    "Health_Concern_Environmental_Quality": {
      "Label": "Environmental Quality"
    },
    "Health_Concern_Immunization": {
      "Label": "Immunization"
    },
    "Health_Concern_Access_To_Healthcare": {
      "Label": "Access To Healthcare"
    },
    "How_Often_Sick": {
      "Label": "How often do you get sick?",
      "Select_Frequency": "Select Frequency",
      "Once_Per_Month": "Once or more a month",
      "Once_Per_Three_Months": "Once every three months",
      "Once_Per_Six_Months": "Once every six months",
      "Once_Per_Year": "Once a year",
      "Rarely": "I rarely get sick"
    },
    "Enough_Energy_For_Daily_Activities": {
      "Label": "Do you feel you have enough energy for your daily activities?"
    },
    "Motivation_For_Goals": {
      "Label": "How motivated are you to achieve your goals? (Scale of 1 to 10)"
    },
    "Dietary_Goals": {
      "Label": "What are your dietary goals?",
      "Select_Dietary_Goals": "Select Dietary Goals",
      "Healthy_Eating_Optimal_Nutrients": "Follow a healthy eating pattern with optimal nutrients across the life span",
      "Weight_Loss": "Focus on variety, nutritional density, and amount to support weight loss",
      "Limit_Sugar_Sodium": "Limit calories from added sugar and saturated fats, and reduce sodium intake",
      "Healthier_Food_More_Water": "Shift to healthier food and beverage choices and drink more water"
    },
    "Condition_Auto_Immune": {
      "Label": "Auto-Immune Disease"
    },
    "Condition_Bowel_Ostomy": {
      "Label": "Bowel Ostomy"
    },
    "Condition_Cancer": {
      "Label": "Cancer"
    },
    "Condition_Celiac": {
      "Label": "Celiac Disease or Gluten intolerance"
    },
    "Condition_Copd": {
      "Label": "Chronic Obstructive Pulmonary Disease (COPD)"
    },
    "Condition_Chf": {
      "Label": "Congestive Heart Failure (CHF)"
    },
    "Condition_Constipation": {
      "Label": "Constipation"
    },
    "Condition_Coronary_Artery": {
      "Label": "Coronary Artery Disease"
    },
    "Condition_Crohns": {
      "Label": "Crohn's Disease"
    },
    "Condition_Cystic_Fibrosis": {
      "Label": "Cystic Fibrosis"
    },
    "Condition_Dimentia_Alzeimer_Parkinson": {
      "Label": "Dementia, Alzheimer's or Parkinson’s"
    },
    "Condition_Diabetes": {
      "Label": "Diabetes or Pre-Diabetes"
    },
    "Condition_Diarrhea": {
      "Label": "Diarrhea"
    },
    "Condition_Diverticulitis": {
      "Label": "Diverticulitis or Diverticulosis"
    },
    "Condition_Eating_Disorder": {
      "Label": "Eating Disorder (anorexia, bulimia, binge-eating)"
    },
    "Condition_Gerd": {
      "Label": "Gastroesophageal Reflux Disease (GERD)"
    },
    "Condition_Gastroparesis": {
      "Label": "Gastroparesis"
    },
    "Condition_Gout": {
      "Label": "Gout"
    },
    "Condition_High_Blood_Pressure": {
      "Label": "High Blood Pressure"
    },
    "Condition_High_Cholesterol": {
      "Label": "High Cholesterol"
    },
    "Condition_Hiv_Immune_Suppression": {
      "Label": "HIV or other Immune Suppression"
    },
    "Condition_Ibs": {
      "Label": "Irritable Bowel Syndrome"
    },
    "Condition_Kidney_Disease": {
      "Label": "Kidney Disease"
    },
    "Condition_Organ_Transplant": {
      "Label": "Organ Transplant"
    },
    "Condition_Osteoporosis": {
      "Label": "Osteoporosis"
    },
    "Condition_Overweight_Obesity": {
      "Label": "Overweight or Obesity"
    },
    "Condition_Pancreatitis": {
      "Label": "Pancreatitis"
    },
    "Condition_Peptic_Ulcer": {
      "Label": "Peptic Ulcers"
    },
    "Condition_Trouble_Chewing_Swallowing": {
      "Label": "Trouble Chewing or Swallowing"
    },
    "Condition_Other": {
      "Label": "Other"
    },
    "Condition_None": {
      "Label": "None"
    },
    "Prescribed_Diet": {
      "Label": "My Clinician or Registered Dietitian has prescribed a diet for me that I’m currently on."
    },
    "Prescribed_Diet_Description": {
      "Label": "",
      "Please_Describe": "Please describe"
    },
    "Low": "Low",
    "High": "High",
    "Disagree": "Disagree",
    "Agree": "Agree",
    "None": "None",
    "Most": "Most",
    "Not": "Not",
    "Very": "Very",
    "No": "No",
    "Had": "Had",
    "Have": "Have",
    "Num_Minutes": "{{lowMins}} to {{highMins}} minutes",
    "Num_Minutes_Optional": "{{lowMins}} to {{highMins}} minutes (Optional)"
  },
  "Manage_Household": {
    "Title": "Manage Household",
    "Account_Holder": "Account Holder",
    "Household_Member": "Household Member",
    "Pending_Invite": "Pending Invite",
    "Awaiting_Purchase": "Awaiting Purchase",
    "Invite_Expired": "Invite Expired",
    "Add_Household_Member": "Add Household Member",
    "Add_Members_Title": "Add Person",
    "Create_New_Profile": "Create a new profile in your account",
    "Create_New_Profile_Description": "You will be responsible for paying for this profile",
    "Link_Existing_Profile": "Link an existing profile to your account",
    "Link_Existing_Profile_Description": "The new household member will join your account",
    "View_Invitations": "View Invitations",
    "Invite": "Invite",
    "Email": "Email",
    "Plan_Successfully_Updated": "Plan Successfully Updated",
    "Members": {
      "Label": "Members",
      "Title": "Your Household Members",
      "Description": "Manage household members",
      "Invite_Successfully_Sent": "Invite Successfully Sent For {{email}}",
      "Invite_Failed": "Invite Failed For {{email}}: {{reason}}",
      "Invited_On": "Invited On: {{ date }}",
      "Expires_On": "Expires On: {{ date }}",
      "No_Household_Invitations": "No Household Invitations"
    },
    "Packages": {
      "Label": "Packages",
      "Title": "Your Household Packages",
      "Description": "Manage household packages",
      "Num_Allocated": "Allocated: {{num}}",
      "Num_Unallocated": "Unallocated: {{num}}",
      "No_Household_Packages": "No Household Packages",
      "Purchase_Household_Packages": "Purchase Household Packages",
      "Packages_Successfully_Purchased": "Packages Successfully Purchased",
      "Packages_Added_To_Cart": "Packages Added To Cart",
      "Packages_Cart_Quantity_Updated": "Packages Cart Quantity Updated",
      "Packages_Removed_From_Cart": "Packages Removed From Cart",
      "Checkout": "Checkout",
      "Packages_Successfully_Allocated_To_Your_Household": "Packages Successfully Allocated To Your Household"
    },
    "Guardians": "Guardians: {{names}}"
  },
  "Manage_Plan": {
    "Title": "Manage Plan",
    "Per_Month": "${{amount}}/mo",
    "Billing_Details": "Billing Details",
    "Upcoming_Payment": "Upcoming payment {{date}}",
    "Access_Ends": "Access ends {{date}}",
    "Period_Ends": "Current billing period ends {{date}}",
    "Cancel_Plan": "Cancel Plan",
    "Cancel_Plan_Question": "Are you sure you want to cancel your plan?",
    "Cancel_Bullet_All_Plans": "This will cancel all plans in your household",
    "Cancel_Bullet_No_Renew": "We will not renew any of your plans",
    "Cancel_Bullet_Payments_End": "Payments for your plan will end on {{date}}",
    "Cancel_Bullet_Access_Ends": "You and your household members will no longer have access to Youtopia starting {{date}}",
    "Memberships_Being_Cancelled": "Plans being cancelled",
    "You_Suffix": "(You)",
    "Cancel_All_Plans": "Cancel All Plans",
    "Cancellation_Scheduled_Title": "Cancellation Scheduled",
    "Cancellation_Scheduled_Body": "All your memberships will automatically cancel on {{date}}.",
    "Reverse_Cancellation": "Reverse Cancellation",
    "Toast_Cancellation_Scheduled": "Cancellation Scheduled",
    "Toast_Cancellation_Reversed": "Cancellation Reversed",
    "Toast_Cancellation_Reversed_Message": "Your Youtopia access will continue.",
    "No_Subscription": "No active subscription was found for this household.",
    "Plan_Details": "Plan Details",
    "Current_Plan": "Current Plan",
    "Upcoming_Plan": "Upcoming Plan",
    "Plan_Renews_On": "This plan renews on {{date}}.",
    "Plan_Renews_As_Upcoming": "This plan runs until {{date}}, then the new plan starts.",
    "Upcoming_Plan_Starts": "The new plan starts on {{date}}.",
    "Change_Window_Opens": "This plan can be changed starting {{date}}.",
    "Change_Blocked_By_Cancellation": "This plan is scheduled to cancel on {{date}}. Reverse the cancellation in Billing Details to change it.",
    "Change_Scheduled_Subtitle": "Changes on {{date}}",
    "Change_Scheduled_Title": "Plan Change Scheduled",
    "Change_Scheduled_Body": "The new plan starts on {{date}}.",
    "Cancel_Change": "Cancel Change",
    "Confirm_Change_Title": "Confirm Plan Change",
    "Confirm_Change": "Confirm Change",
    "Change_Summary": "{{member}}'s plan will change to {{name}}.",
    "Change_Summary_Self": "Your plan will change to {{name}}.",
    "New_Monthly_Price": "New monthly price",
    "Household_Monthly_Total": "Household monthly total",
    "One_Time_Fee": "One-time fee",
    "One_Time_Fee_Charged_On": "The one-time fee is charged on {{date}}, when the new plan starts.",
    "Change_Takes_Effect": "Nothing changes today. The current plan runs until {{date}}, and the new plan and price start then.",
    "Replaces_Scheduled_Change": "This replaces the plan change already scheduled.",
    "Toast_Change_Scheduled": "Plan Change Scheduled",
    "Toast_Change_Scheduled_Message": "The new plan starts on {{date}}.",
    "Toast_Change_Cancelled": "Plan Change Cancelled",
    "Toast_Change_Cancelled_Message": "The current plan continues."
  },
  "Subscription": {
    "Get_Subscriptions_Error": "Failed To Retrieve Your Plan",
    "Cancel_Error": "Failed To Cancel Plan",
    "Cancel_Already_Scheduled": "This plan is already scheduled to cancel",
    "Reverse_Error": "Failed To Reverse Cancellation",
    "Reverse_Lapsed": "The billing period has ended, so this cancellation can no longer be reversed",
    "Change_Preview_Error": "Failed To Price This Plan Change",
    "Change_Error": "Failed To Schedule This Plan Change",
    "Change_Reverse_Error": "Failed To Cancel This Plan Change",
    "Change_Window_Closed": "This plan cannot be changed yet. Try again once the change window opens",
    "Change_Locked_Cancelling": "This plan is scheduled to cancel. Reverse the cancellation first",
    "Change_Not_Billing": "This plan is no longer billing, so it cannot be changed",
    "Change_Nothing_Scheduled": "There is no scheduled plan change to cancel",
    "Change_Same_Plan": "This membership is already on that plan"
  },
  "Login": {
    "Title": "Login"
  },
  "Choose_Plan": {
    "Title": "Choose Your Plan",
    "Precision_Title": "What level of precision would you like?",
    "Precision_Description": "Get the nutrients yFood As Medicine, Informed by Your Biologyour body needs your way, with ease.",
    "Number_Of_Packages": "Number Of Packages",
    "Price_Per_Month": "{{price}}/month",
    "Add_Package_To_Plan": "Add {{packageName}} To My Plan",
    "Automation": {
      "Name": "Automation",
      "Description": "Automation is a core part of your membership. Each member will receive all automation features.",
      "Additional_Household_Members": "Additional Household Members",
      "Additional_Household_Members_Description": "The more people on your plan, the more you save: $40 for one, $60 for two, and just $80 total for three or more. Discounts will be applied once new members have joined.",
      "Whats_Included": "What's Included",
      "Feature": {
        "Meals_Scored": "No guessing, all meals instantly scored to match your precise health needs.",
        "Preferences": "Remembers your preferences: allergies, tastes, ingredient quality, dietary rules, cuisine, food dislikes, etc.",
        "Meal_Plan": "Auto-fills your 10-day meal plan to match your nutrient goals, budget and tastes.",
        "Household_Meal_Plan": "Coordinates household member’s eating plans in a single, unified mealtime plan.",
        "Meal_Sizing": "Sizes meals closely to your energy needs and targets",
        "Avoid_Harmful_Ingredients": "Automatically avoids 265+ harmful ingredients",
        "Certified_Network": "Finds the healthiest options when dining out from our certified network",
        "Recommendations": "Learns from your choices to improve future recommendations",
        "Auto_Track": "Auto track what you ate and which nutrients you received",
        "Rescoring": "Re-scores recommendations in real time as you choose and rate meals"
      }
    },
    "FAQs": "FAQs",
    "FAQs_Description": "Here is a short description describing Precision Type.",
    "FAQ_1_Title": "What is The Starting Line?",
    "FAQ_1_Description": "Some description of The Starting Line.",
    "FAQ_2_Title": "How are meals matched to my biometric data?",
    "FAQ_2_Description": "Some description of how meals are matched to your biometric data.",
    "FAQ_3_Title": "What toxins are blocked?",
    "FAQ_3_Description": "Some description of the toxins that are blocked."
  },
  "Create_Account": {
    "Title": "Create Account",
    "Welcome_Title": "Welcome to Youtopia",
    "Welcome_Description": "Welcome text here, fill out our application and find out instantly if you’re approved!",
    "Your_Personal_Information": "Your Personal Information",
    "Legal_First_Name": "Legal First Name",
    "Legal_Last_Name": "Legal Last Name",
    "Date_Of_Birth": "Date Of Birth",
    "Email": "Email",
    "Home_Zip_Code": "Home Zip Code",
    "How_Did_You_Learn_About_Youtopia": "How Did You Learn About Youtopia?",
    "Doctor": "Doctor",
    "Source": "Source",
    "Choose_Source": "Choose Source",
    "Doctors_Name": "Doctor's Name",
    "I_Attest": "I attest that...",
    "Min_Meals_Per_Week": "I’m willing to commit to eating Youtopian food for at least {{num}} meals in a week",
    "I_Acknowledge_The": "I acknowledge the",
    "Terms_Of_Service": "Terms Of Service",
    "Privacy_Policy": "Privacy Policy",
    "Consent_To_Treat": "Consent To Treat",
    "I_Am_Over_18": "I am 18 years of age or older"
  },
  "Payment": {
    "Title": "Payment",
    "Delivery_Of": "Delivery {{title}}",
    "Unscheduled_Delivery": "Not yet scheduled",
    "Delivery_Window": "Delivery Window",
    "Delivery_No_Address": "Add a delivery address to your household to schedule your deliveries.",
    "Delivery_Not_Yet_Planned": "We haven't scheduled your deliveries yet. Check your delivery availability on the Delivery tab under Schedule & Purchase.",
    "Delivery_Not_Scheduled": "Deliveries Not Scheduled",
    "Meal_Count": "{{count}} items",
    "Meal_Count_One": "1 item",
    "Meal_Gap_Title": "{{name}} has no {{occasion}}",
    "Meal_Gap_Body": "Would you like to add one before checking out?",
    "Meal_Gap_Add": "Add {{occasion}}",
    "Review_Order": "Review Order",
    "Review_Order_Description": "Select the payment method for your initial and future monthly payments.",
    "Order_Summary": "Order Summary",
    "Review_And_Pay": "Review and Pay",
    "Review_And_Pay_Description": "Review your monthly total and payment details before completing setup.",
    "Payment_Method": "Payment Method",
    "Payment_Methods": "Payment Methods",
    "Default_Payment": "Default Payment",
    "Select_Payment_Method": "Select Payment Method",
    "Add_Payment_Method": "Add Payment Method",
    "Add_Payment": "Add Payment",
    "Edit_Payment": "Edit Payment",
    "Or": "Or",
    "Credit_Or_Debit_Card": "Credit or Debit Card",
    "Full_Name": "Full Name",
    "Billing_Address": "Billing Address",
    "Address": "Address",
    "Address_2": "Address 2",
    "City": "City",
    "State": "State",
    "Zip_Code": "Zip Code",
    "Country": "Country",
    "Payment_Info_Will_Be_Saved": "Your payment information will be saved for future purchases.",
    "Save_Address_To_Address_Book": "Save address to Address Book for future use.",
    "Complete_Order": "Complete Order",
    "Init_Error_Message": "We couldn't load your order. Please try again.",
    "Processing_Payment": "Processing Payment",
    "Payment_Successful": "Payment Successful",
    "Payment_Failed": "Payment Failed",
    "Payment_Method_Failed": "Payment Method Failed",
    "Order_Placed_Successfully": "Order Placed Successfully",
    "Order_Payment_Failed": "Order Payment Failed",
    "Payment_Unconfirmed": "We couldn't confirm your payment. Check your recent orders before trying again.",
    "Checkout_Retry_Failed": "We still couldn't process this payment. Try a different card, or contact support if it keeps happening.",
    "Clear_Cart": "Clear Cart",
    "Clear_Cart_Confirm_Title": "Clear cart?",
    "Clear_Cart_Confirm_Message": "This removes everything from your cart. This can't be undone.",
    "Clear_Cart_Confirm": "Clear Cart",
    "Empty_Guest_Confirm_Title": "Guest with no items",
    "Empty_Guests_Confirm_Title": "Guests with no items",
    "Empty_Guest_Confirm_Message": "{{names}} has no items and will be removed if you place this order.",
    "Empty_Guests_Confirm_Message": "{{names}} have no items and will be removed if you place this order.",
    "Empty_Guest_Confirm": "Place order",
    "Add_On_Not_Included": "Not Included In Your Order",
    "Add_On_Dropped": "We could not include the following with your order: {{items}}. You have not been charged for them.",
    "Add_On_Dropped_Item": "{{name}} for Delivery {{number}} of {{count}} ({{date}})",
    "Get_Wallet_Error": "Failed To Retrieve Wallet",
    "Add_Payment_Method_Error": "Failed To Add Payment Method",
    "Unable_To_Add_Payment_Method": "Unable to add payment method. Please try again.",
    "Update_Payment_Method_Error": "Failed To Update Payment Method",
    "Update_Payment_Method_Billing_Address_Error": "Failed To Update Payment Method Billing Address",
    "Update_Default_Payment_Method_Error": "Failed To Update Default Payment Method",
    "Delete_Payment_Method_Error": "Failed To Remove Payment Method",
    "Get_Payments_Error": "Unable to load payment history. Please try again.",
    "Get_Order_Totals_Error": "Failed to Get Order Totals",
    "Post_Order_Checkout_Error": "Failed to Checkout Order",
    "Checkout_Error_Declined": "Your card was declined. Please try a different payment method or contact your card issuer.",
    "Checkout_Error_Insufficient_Funds": "Your card has insufficient funds. Please try a different payment method.",
    "Checkout_Error_Expired": "Your card appears to be expired. Please update your payment method and try again.",
    "Checkout_Error_Cvv": "The security code (CVV) is incorrect. Please update your payment method and try again.",
    "Checkout_Error_Address": "The billing address doesn't match your card. Please update your payment method and try again.",
    "Checkout_Error_Invalid_Card": "Your card details are invalid. Please update your payment method and try again.",
    "Checkout_Error_Not_Supported": "This card type is not supported. Please try a different payment method.",
    "Checkout_Error_Limit": "This payment exceeds a limit set by your card issuer. Please contact them or try a different payment method.",
    "Checkout_Error_Verification_Required": "Your card issuer requires additional verification. Please contact them and try again.",
    "Checkout_Error_Session_Expired": "Your payment session has expired. Please try again.",
    "Checkout_Error_Temporary": "A temporary error occurred. Please wait a moment and try again.",
    "Checkout_Error_Generic": "Payment could not be processed. Please try a different payment method or contact support.",
    "Checkout_Error_Delivery_Unplanned": "None of your items can be delivered on the days you chose. Set your delivery availability on the Delivery tab under Schedule & Purchase, then come back to checkout.",
    "Checkout_Error_Delivery_No_Address": "Your household has no delivery address, so we can't schedule your deliveries. Add one, then come back to checkout.",
    "Checkout_Error_Delivery_Not_Quoted": "Your deliveries haven't been scheduled yet. Go back to your order and return to checkout to schedule them.",
    "Checkout_Error_Delivery_Capacity": "A delivery time we had scheduled for your order was taken before you finished checking out. Go back to your order and return to checkout to reschedule your deliveries.",
    "Checkout_Error_Delivery_Stale": "Your delivery schedule is out of date. Go back to your order and return to checkout to reschedule your deliveries.",
    "Checkout_Error_Delivery_Failed": "We couldn't schedule your deliveries just now. Please try again in a few minutes.",
    "Stranded_No_Delivery": "No delivery reaches this item",
    "Review_Delivery": "Review delivery availability",
    "Stranded_No_Stock": "Sold out for that delivery",
    "Not_Yet_Scheduled": "Not yet scheduled",
    "No_Window_On_Day": "No delivery window on {{day}}",
    "Checkout_Loading": "Please wait while your order is updated.",
    "Checkout_Select_Payment": "Select a payment method to complete your order.",
    "Checkout_Review_Meals": "Some items can't be delivered. Remove them or change their delivery day to complete your order.",
    "Checkout_No_Meals": "Add an item to complete your order."
  },
  "Home": {
    "Title": "Youtopia",
    "Tab_Label": "Home",
    "Welcome_Title": "Welcome To Youtopia!",
    "Welcome_Description": "Welcome to Youtopia. You're on your way to effortless health—enjoying food that fits your body and preferences!",
    "Welcome_To_Youtopia_Task_Title": "Welcome To Youtopia",
    "Welcome_To_Youtopia_Task_Subtitle": "You have {{num}} tasks to complete",
    "Welcome_To_Youtopia_Task_Description": "To finish setting up your Youtopia account, complete the following tasks.",
    "Finish_Household_Task_Title": "Completing Your Profile",
    "Finish_Household_Task_Subtitle": "Finish Your Household",
    "Finish_Household_Task_Description": "Add family members to manage your household and strive for health together.",
    "Health_Sharing_Task_Title": "Your health data, your choice",
    "Health_Sharing_Task_Subtitle": "Sharing decision needed",
    "Health_Sharing_Task_Description": "You can now choose which of your guardians can see your health and nutrition information.",
    "Health_Sharing_Task_Action": "Decide now",
    "View_Tasks": "View Tasks",
    "User_Invited_You": "{{name}} Invited you!",
    "User_Invited_You_Description": "Join {{name}}’s household and start getting and staying healthy the easy way!",
    "Accept_Invite": "Accept Invite",
    "Setup_Complete": "Setup complete",
    "Setup_Complete_Description": "You can now get healthy the easy way!",
    "Setting_Up_Household": "Setting up your household",
    "Setting_Up_Household_Description": "This will only take a moment.",
    "Household_Members_Invited": "Household Members Invited",
    "Household_Members_Invited_Description": "Household Member Invitations Have Been Sent!"
  },
  "Nutrients": {
    "Title": "Nutrients",
    "Tab_Label": "Nutrients",
    "Schedule_Ahead_And_Save": "Schedule Ahead and Save",
    "Schedule_And_Purchase": "Schedule & Purchase",
    "Schedule_And_Purchase_Description": "Order ahead for optimal savings & menu variety.",
    "Setting_Up_Household": "Setting up your household — this will only take a moment.",
    "On_Demand_Title": "Need a meal now or in the next 2 days?",
    "Pickup": "Pickup",
    "Delivery": "Delivery",
    "Dine_Out": "Dine Out",
    "Orders_And_Status": "Orders & Status",
    "Review_Meals": "Review Items",
    "Review_Meals_Description": "10 dine out selections",
    "Nutrient_Preferences": "Nutrient Preferences",
    "Upcoming_Dining_Event": "Upcoming Dining Event",
    "In_Progress_Dining_Event": "Happening Now",
    "Past_Dining_Event": "Past Dining Event",
    "View_All_Dining_Events": "View all dining events"
  },
  "Schedule_Ahead_Savings": {
    "Title": "Schedule Ahead Savings",
    "Description": "Families who take advantage of schedule ahead and save, on average save up to $150 per week!",
    "Last_Week": "Last Week",
    "Today": "Today",
    "This_Week": "This Week",
    "Num_Of_Num": "${{num1}} of ${{num2}}"
  },
  "Establishment_Filters": {
    "Title": "Dining Experience Filters",
    "Title_With_Count": "Dining Experience Filters, {{count}} applied",
    "Reset": "Reset",
    "Apply": "Apply",
    "Pet_Friendliness": "Pet-Friendliness",
    "Dining_And_Service_Options": "Dining and Service Options",
    "Audience_Suitability": "Audience Suitability",
    "Food_And_Beverage_Offerings": "Food and Beverage Offerings",
    "Entertainment_And_Amenities": "Entertainment and Amenities",
    "Allows_Dogs": "Allows Dogs",
    "Curbside_Pickup": "Curbside Pickup",
    "Delivery": "Delivery",
    "Dine_In": "Dine-In",
    "Reservations_Accepted": "Reservations Accepted",
    "Take_Out": "Take Out",
    "Outdoor_Seating": "Outdoor Seating",
    "Good_For_Children": "Good for Children",
    "Kids_Menu": "Kids Menu",
    "Good_For_Groups": "Good for Groups",
    "Good_For_Watching_Sports": "Good for Watching Sports",
    "Serves_Breakfast": "Serves Breakfast",
    "Serves_Brunch": "Serves Brunch",
    "Serves_Lunch": "Serves Lunch",
    "Serves_Dinner": "Serves Dinner",
    "Serves_Wine": "Serves Wine",
    "Serves_Beer": "Serves Beer",
    "Serves_Cocktails": "Serves Cocktails",
    "Serves_Coffee": "Serves Coffee",
    "Serves_Dessert": "Serves Dessert",
    "Serves_Vegetarian_Food": "Serves Vegetarian Food",
    "Live_Music": "Live Music",
    "Free_Parking_Lot": "Free Parking Lot",
    "Free_Street_Parking": "Free Street Parking",
    "Valet_Parking": "Valet Parking",
    "EV_Charging": "EV Charging",
    "Restrooms": "Restrooms"
  },
  "On_Demand": {
    "Title": "On Demand Ordering",
    "Delivery": "Delivery",
    "Pickup": "Pickup",
    "Dine_Out": "Dine Out",
    "Find_Type_Recommendations": "Find {{type}} Recommendations",
    "Find_Recommendations": "Find Recommendations",
    "When": "When",
    "Dining_With": "Dining With",
    "Im_At_Restaurant": "I'm at the Restaurant",
    "Search_This_Area": "Search This Area",
    "Top_Recommendations": "Top Recommendations for your group",
    "Top_Recommendations_Description": "Preferences and Locations listed in order by the Best Match Score for your group.",
    "Group_Score": "GROUP SCORE",
    "Group_Score_Aria": "Group score {{ score }}, range {{ low }} to {{ high }}",
    "No_Establishments_In_Area": "No Establishments In This Area",
    "Mi": "mi",
    "View_Menu": "View Menu",
    "Details": "Details",
    "No_Delivery_Addresses": "No delivery addresses saved",
    "Manage_Addresses": "Manage Addresses",
    "Add_Address": "Add Address",
    "Default": "Default",
    "Too_Far_From_Restaurant": "Too far from restaurant",
    "Current_Location": "Current Location",
    "Date_And_Time": "Date and Time",
    "Occasion": "Occasion",
    "Not_Selected": "Not selected",
    "Edit_Title": "Edit",
    "Location": "Location",
    "Meal_Occasion": "Meal Occasion",
    "Save_Changes": "Save Changes",
    "Switching_Order_Type": "Failed to update order type. Please try again.",
    "Time_Slots_Error": "Failed to load time slots",
    "ASAP": "ASAP",
    "Fulfillment_Window": "Time",
    "Fulfillment_Windows_Error": "Failed to load fulfillment window settings",
    "Establishment_Closed_During_Selected_Time": "Establishment Closed During Selected Time",
    "Add_Address_Before_Proceeding": "Please add a delivery address before finding recommendations."
  },
  "Establishment_Detail": {
    "Get_Directions": "Get Directions",
    "Share": "Share",
    "Address": "Address",
    "Hours": "Hours",
    "Phone": "Phone",
    "Closed": "Closed",
    "Closes": "Open - Closes {{time}}",
    "Opens": "Closed - Opens {{time}}",
    "Temporarily_Closed": "Temporarily Closed",
    "Open_24_Hours": "Open 24 Hours",
    "Create_Dining_Event": "Create Dining Event",
    "View_Menu": "View Menu",
    "Arrival_Info": "Be notified with your Youtopia certified meals when you arrive at your dining location.",
    "Share_Failed": "Unable to share"
  },
  "Menu": {
    "Title": "Menu",
    "Eating_Occasion": "Meal Type",
    "No_Menu_Items": "No Menu Items",
    "Loading_Menu_Items": "Finding items for this slot...",
    "Menu_Load_Failed": "We couldn't load items for this slot.",
    "Add_To_Cart": "Add To Cart",
    "Remove_From_Cart": "Remove From Cart",
    "Item_Quantity": "{{quantity}}x",
    "Increment_Quantity": "Increase quantity",
    "Decrement_Quantity": "Decrease quantity",
    "Remove_Item": "Remove item from cart",
    "Check_Out": "Check Out",
    "Available_Sizes": "Available Sizes",
    "Available_Sizes_Description": "Your Nutrient Score™ is dependent on size selected.",
    "Num_Cal": "{{num}} cal",
    "Cal_Unavailable": "- cal",
    "Ingredients": "Ingredients",
    "Nutrition_Facts": "Nutrition Facts",
    "Heating_Instructions": "Heating Instructions",
    "Heating_Instructions_Label": "Microwave for {{microwaveMins}} minutes and {{microwaveSecs}} seconds. Let cool for {{standingMins}} minutes and {{standingSecs}} seconds before serving.",
    "No_Sizes_Available": "No Sizes Available",
    "No_Nutrition_Facts": "No Nutrition Facts",
    "No_Nutrients": "No Nutrients",
    "Nutrient_Categories": {
      "CDEN-VitaminsAndMinerals": "Critical Vitamins & Minerals",
      "CDEN-Protein": "Critical Protein",
      "CDEN-Fiber": "Critical Fiber",
      "CDEN-Omega3": "Critical Omega-3",
      "RDEN": "Required Vitamins & Minerals",
      "RDEBN": "Required Energy Needs",
      "N2MIN": "Nutrients to Minimize",
      "Water": "Water",
      "Uncategorized": "Other Nutrients"
    },
    "Recipe_By": "Recipe By {{name}}",
    "By_Chef_Name": "By Chef {{name}}",
    "At_Establishment": "at {{name}}",
    "View_More": "View More",
    "Add_To_Order": "Add To Order",
    "View_Details": "View Details",
    "Save_Schedule_Updates": "Save Schedule Updates",
    "Swap_Menu_Item": "Swap Menu Item",
    "Add_Menu_Item": "Add Menu Item",
    "View_Cart": "View Cart",
    "Meals": "Items",
    "Meals_One": "Item",
    "Saving_Discount": "Saving ${{amount}} ({{percent}}%)",
    "Your_Previous_Rating": "Your previous rating",
    "Your_Rating": "Your Rating",
    "Available_Sizes_Info_Title": "Available Sizes",
    "Available_Sizes_Info_Body": "Different portion sizes may affect your personalized nutrient score. Select the size that best fits your dietary needs.",
    "Nutrition_Facts_Info_Title": "Nutrition Facts",
    "Nutrition_Facts_Info_Body": "Nutrition facts are based on the selected portion size and may vary based on preparation.",
    "Filter_Actions_Title": "Want to see more options?",
    "Filter_Actions_Empty_Title": "Search again or clear filters",
    "Filter_Actions_Subtitle": "Your allergens, intolerances, and certifications always stay in place.",
    "Clear_Filters": "Clear Filters",
    "Edit_Filters": "Edit Filters",
    "No_Order_Times_Left_Today": "No Order Times Left Today",
    "No_Order_Times_Left_Today_Message": "The last pickup and delivery time for today has passed. Try again tomorrow, or schedule an order for later."
  },
  "SNS_Menu": {
    "Title": "Recommended Items",
    "Swap_Title": "Swap {{occasion}} - {{date}}",
    "Add_Meal_Title": "Add Item to {{date}}",
    "Nothing_Eligible_Title": "This slot needs attention",
    "Nothing_Eligible_Body": "Nothing available for this day fits your standards, allergens and budget. Try another day, or adjust your filters.",
    "Out_Of_Area_Title": "This address is outside our delivery area",
    "Out_Of_Area_Body": "Your household's delivery address is outside the area we currently serve, so there are no Schedule & Save items available for it. Update your household's default address to one within our area."
  },
  "Menu_Filters": {
    "Title": "Menu Filter",
    "Cuisine_Preferences": "Cuisine Preferences",
    "Spice_Level": "Spice Level",
    "Required_Ingredient_Standards": "Required Ingredient Standards",
    "Certifications": "Certifications",
    "Common_Dislikes": "Common Dislikes",
    "Apply_Title": "How would you like these filters applied?",
    "Apply_Description": "Going forward will save these filters to [Name]s profile and apply them automatically next time you search.",
    "One_Time": "One Time",
    "Going_Forward": "Going Forward",
    "Plus_More": "+ {{count}} more",
    "Preferences_Update_Successful": "Preferences and Standards Updated Successfully",
    "Preferences_Update_Failed": "Failed To Update Preferences and Standards",
    "Unsaved_Preferences": "Unsaved Preferences",
    "Changes_Will_Be_Discarded": "Your changes will be discarded"
  },
  "Planned_Nutrients": {
    "For_Others_Similar_To_You": "For others similar to you",
    "Complete_Starting_Line": "Complete Your Starting Line to start ordering and tracking your nutrients.",
    "No_Results_Yet": "Your daily nutrient results will show up here once you've enjoyed some meals.",
    "Results_Unavailable": "We couldn't load your daily nutrient results right now.",
    "Get_Started": "Get Started",
    "View_Nutrient_Results": "View Nutrient Results",
    "Nutrient_Automation_Settings": "Nutrient Profile Settings"
  },
  "My_Wellness": {
    "Title": "Wellness",
    "Tab_Label": "Wellness",
    "Getting_Started": "Getting Started",
    "My_Wellness_Plan": "My Wellness Plan",
    "Plan_Description": "Building your plan is the first step to better health & wellness. Get started by completing <b>The Starting Line™</b>, your first Youtopia experience. Begin your journey by filling out your Health Profile.",
    "Explore_Starting_Line": "Explore The Starting Line™",
    "Begin_Health_Profile": "Begin My Health Profile",
    "Actions": {
      "My_Goals": "My Goals",
      "Health_Profile": "Health Profile",
      "My_Progress": "My Progress",
      "Nutrient_Plan": "Prescriptive Nutrient Plan",
      "Support": "Support",
      "Televisits": "Televisits"
    },
    "Discovery": {
      "Title": "Your Discovery Experiences",
      "Learn_More": "Learn More",
      "Explore": "Explore",
      "What_Are_Discovery": "What are Discovery Experiences?",
      "Starting_Line": "The Starting Line™",
      "Vitamin_Optimizer": "Vitamin & Mineral Optimizer"
    },
    "Health_Profile": {
      "Title": "My Health Profile",
      "View_More": "View More",
      "Personal_Goals": "My Personal Goals",
      "Update_Medications": "Update Medications",
      "Fitness_Questionnaire": "Fitness Questionnaire",
      "Sleep_Questionnaire": "Sleep Questionnaire",
      "Goal_1": "I want to use nutrition as a tool in my fight against a diagnosed chronic disease.",
      "Goal_2": "I want to lose weight.",
      "Goal_3": "I want to understand what, when, and how much to eat."
    },
    "Nutrients": {
      "Title": "Your Nutrients",
      "Not_Calculated": "Your Nutrients haven't been calculated yet",
      "Met_Last_30_Days": "Nutrients met last 30 days"
    },
    "Card": {
      "My_Wellness_Score": "My Wellness Score",
      "View_Detail": "View Detail",
      "Get_Your_Score": "Get your Wellness Score",
      "Score_Description": "To receive your Wellness Score you need to complete the Starting Line assessment.",
      "Get_Started": "Get started",
      "Upgrade_Plan": "Upgrade Your Plan",
      "No_Package_Description": "Your current wellness insights are based on people with a similar profile. Upgrade your plan to unlock your personalized wellness score.",
      "Congrats_Message": "Congratulations on your progress towards optimizing your health! Your results have been reviewed by Youtopia’s medical and nutritional team. Based on those results, we have fine-tuned your Personal Nutrient Score™ on Youtopia’s entrees and consumables to continue supporting your health and wellness journey.",
      "Progress_Message": "Your results indicate you are progressing toward optimal health.",
      "Expires": "Expires: {{date}}",
      "Low_High": "Low/High",
      "Optimal": "Optimal",
      "Next_Check": "Your next check-up is in {{days}} days",
      "Schedule_Appointment": "Schedule Appointment"
    }
  },
  "Wellness_Results": {
    "Title": "Wellness Checker",
    "Wellness_Checker": "Wellness Checker",
    "Last_Tested": "Last Tested: {{date}}",
    "Overall_Score": "Overall Score",
    "Expires": "Expires: {{date}}",
    "Experience_Progress": "Experience Progress",
    "Category_Score_Breakdown": "Wellness Score Breakdown",
    "Category_Score_Breakdown_Description": "Your Overall Score represents a blend of scores across a number of wellness categories. Tap into each category to learn more about your specific results.",
    "Wellness_Score": "Wellness Score",
    "Low_High": "Low/High",
    "Severity": {
      "Optimal": "Optimal",
      "Moderate": "Moderate",
      "Critical": "Critical",
      "Severe": "Severe"
    },
    "Optimal": {
      "Title": "Optimal",
      "Label": "Your results indicate you are progressing toward optimal health.",
      "Description": "Congratulations on your progress towards optimizing your health! Your results have been reviewed by Youtopia's medical and nutritional team. Based on those results, we have fine-tuned your Personal Nutrient Score™ on Youtopia's entrees and consumables to continue supporting your health and wellness journey."
    },
    "Needs_Improvement": {
      "Title": "Needs Improvement",
      "Label": "Your results indicate you have item(s) that need improvement.",
      "Description": "Your results have been reviewed by Youtopia's medical and nutritional team. Based on those results, we have adjusted your Personal Nutrient Score™ on Youtopia's entrees and consumables to indicate which of these will most likely help improve your results and health."
    },
    "Needs_Medical_Review": {
      "Title": "Needs Medical Review",
      "Label": "Your results indicate you have item(s) that need medical review.",
      "Description": "If you have not already been notified by our affiliated medical team at MaxWell Clinic or taken action with your personal clinician, Youtopia can help you understand the next steps."
    },
    "Needs_Medical_Attention": {
      "Title": "Needs Medical Attention",
      "Label": "Your results indicate you have item(s) that need medical attention soon.",
      "Description": "If you have not already been notified by our affiliated medical team at MaxWell Clinic or taken action with your personal clinician, Youtopia can help you understand the next steps."
    }
  },
  "Discovery_Experiences": {
    "Title": "Discovery Experiences",
    "What_Are_Experiences": "What are Discovery Experiences?",
    "The_Starting_Line": "The Starting Line™",
    "The_Food_Processor": "The Food Processor",
    "The_Vitamin_And_Mineral_Optimizer": "The Vitamin & Mineral Optimizer",
    "The_Toxin_Eliminator": "The Toxin Eliminator",
    "The_Genetic_Optimizer": "The Genetic Optimizer",
    "FDA_Disclaimer": "FDA Disclaimer",
    "FDA_Disclaimer_Text": "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information provided is for educational purposes only and is not intended as medical advice. Please consult with a qualified healthcare professional before making any dietary or lifestyle changes.",
    "FDA_Link_Text": "Please read our FDA Disclaimer that applies to all Discovery Experiences."
  },
  "Discovery_Experiences_Tour": {
    "Main_Page": "Discover Your Most Nourished & Vibrant Self with Precision Nourishment™",
    "Main_Page_Desc": "Discovery Experiences are here to help you uncover Precision Nourishment™, a state of complete physical, nutritional, mental, social, and spiritual wellbeing.",
    "Main_Page_Desc2": "Youtopia utilizes food, hydration, toxin elimination, sleep optimization, fitness optimization, mindset, self knowledge, love/friendship, spirituality, and purpose/values as part of our Precision Nourishment™ program.",
    "Welcome_Image_Alt": "Welcome to Youtopia Discovery Experiences",
    "Clinic_Founder_Image_Alt": "David Haase, MD, founder of MaxWell Clinic",
    "Clinic_Logo_Image_Alt": "MaxWell Clinic® logo",
    "Start_Tour_Button": "Begin the Tour",
    "Page_Title": "Getting started",
    "Slide1_Title": "Youtopia Puts YOU at the Center of Everything",
    "Slide1_Desc": "Participation in Discovery Center Experiences provides substantial insights into your overall wellness and possible ways to improve it.",
    "Slide1_Desc2": "Our goal is to help YOU and your loved ones achieve vibrant health and longevity with Precision Nourishment™ as a foundation.",
    "Slide1_Desc3": "Youtopia: 100% You-based & You-built",
    "Slide2_Title": "Discover How Good You Can Feel",
    "Slide2_Desc": "Youtopia's Discovery Center provides simple, affordable testing equipment and laboratory screenings to gain insight into your wellness and unique daily nutrient needs.",
    "Slide2_Desc2": "First, you'll provide some health information to help us get to know you better. Then you'll visit a Discovery Center near you to participate in the experiences. Afterwards, we'll use your results to help improve your overall wellness.",
    "Slide3_Title": "The Best Medical and Nutritional Insights Around",
    "Slide3_Desc": "Youtopia and our affiliated medical clinicians and nutritionists at MaxWell Clinic® analyze your results and integrate them with the world's best medical and nutritional knowledge to determine how to best help you optimize your health with Precision Nourishment™.",
    "Slide3_Desc_Founder": "Get to know the founder, David Haase, MD",
    "Slide3_Desc_Know_Clinic": "Get to know MaxWell Clinic®",
    "Slide4_New_Title": "How Will Youtopia Work with Your Personal Doctor?",
    "Slide4_New_Desc": "The medical profession is complex and requires many professionals working together. Please continue to consult with your own personal medical doctor alongside Youtopia. Youtopia approaches health and wellness with preventative and reversal endeavors—it is well established that food optimized around your body is the most powerful medicine on the planet.",
    "Slide4_New_Desc2": "Keep in mind, Youtopia provides you capabilities that most doctors are not trained to do. Consider this observation:",
    "Slide4_New_Desc3": "We will work in conjunction with your current medical treatments to align and optimize your nutrients with your prescriptions and prescribed supplements.",
    "Slide4_New_Quote": "Today, most medical schools in the United States teach less than 25 hours of nutrition over four years and in fact, less than 20 percent of medical schools have a single required course in nutrition. It's outrageous!",
    "Slide4_New_Quote_Author": "– David Eisenberg M.D.",
    "Slide4_New_Quote_Ref": "Harvard T.H. Chan School of Public Health",
    "Slide4_Title": "Automatic Adjustments Based on Your Progress",
    "Slide4_Desc": "Each time you participate in a Discovery Center Experience, we make adjustments to your daily nutrient needs and Personal Nutrient Score™ to help you reach your potential.",
    "Slide4_Desc2": "Your results and progress are tracked and always available to you.",
    "Slide4_Note": "For example illustration only",
    "Slide4_Link_text": "View a sample Results experience",
    "Slide5_Title": "High-Quality Food for Your Unique Needs",
    "Slide5_Desc": "By participating in the Discovery Center, each entree will have a personalized Nutrient Score™ that indicates how well it meets your body's unique needs. Our goal is to help you achieve vibrant health and longevity with Prescriptive Nutrients™ as a foundation.",
    "Slide6_Title": "Your Discovery Center Experience Begins with The Starting Line™",
    "Slide6_Desc": "Discovery Center Experiences are carefully curated, targeted assessments that combine health history insights with informative test results to help identify ways to improve your health.",
    "Slide6_Desc2": "<b>The Starting Line™</b> Experience is the first foundational Experience that helps build a baseline for your current health and unique nutrient needs.",
    "Slide9_Title": "Your Personalized Health & Wellness Plan",
    "Slide9_Desc": "After completing each Discovery Center Experience, you'll receive an updated Health & Wellness Plan, providing insights and guidance for your journey towards optimizing your health.",
    "Slide10_Title": "Your Personal Prescriptive Nutrient Plan",
    "Slide10_Desc": "Take control of your wellness with Your Personal Prescriptive Nutrient Plan, uniquely calibrated for your body's needs. You hold the power to follow your plan independently, or for simplicity and ease, opt for Youtopia's meals. The higher the meal's score, the better it aligns with your specific nutrient plan. Simple choices, powerful health.  Your nourishment optimized and life simplified!",
    "Last_Slide_Title": "We'll Guide You Every Step of the Way",
    "Last_Slide_Desc": "Youtopia is here to guide you through your Discovery Experience journey. Here's an overview of what you can expect:",
    "Last_Slide_Blocks": {
      "Block1": {
        "Title": "Begin The Starting Line™ Experience",
        "Desc": "A brief health history intake form helps establish a baseline for your current wellness and physical well-being."
      },
      "Block2": {
        "Title": "Initial Baseline Testing",
        "Desc": "Complete a number of physical assessment tests. Bio-extractions will test 63 analytes (which are compounds in your blood). Don't worry—it's not too bad!"
      },
      "Block3": {
        "Title": "Baseline Test Analysis",
        "Desc": "Your test results are reviewed by affiliate clinicians and nutritionists, alongside your health history information. This team uses your information to determine your daily nutrient needs and provides Prescriptive Nutrients™."
      },
      "Block4": {
        "Title": "Baseline Results & Insights",
        "Desc": "In about 14-21 days, you'll get your test results via the Youtopia app. Youtopia will present your results in an easy-to-understand format, helping you understand them and how they may impact your wellness and functional areas of the body."
      },
      "Block5": {
        "Title": "Health & Wellness Televisit",
        "Desc": "Depending on your Health History and test results, a Telewellness or Telehealth visit may be your next steps."
      },
      "Block6": {
        "Title": "Your Daily Personal Prescriptive Nutrient Plan",
        "Desc": "Along with your test results, you'll also see your new Personal Nutrient Score™ on each meal. The Nutrient Score™ helps guide you to the best menu recommendations targeted to your optimal daily nutrient needs.</br></br>You'll also receive access to personalized goals, resources, and daily nutrient targets on your way towards optimal health."
      },
      "Block7": {
        "Title": "Unlock Additional Experiences",
        "Desc": "Each Discovery Experience is designed to help you optimize your health with Precision Nourishment™.</br></br>You'll first complete The Starting Line™ Experience. After receiving your results, you will then be able to complete the four additional Foundational Experiences to learn more about your health and well-being. Afterwards, you'll unlock even more additional Experiences."
      },
      "Block8": {
        "Title": "Retest and Review Your Progress",
        "Desc": "In order to monitor improvements, health conditions, and check for early symptoms of other health concerns, Youtopia requires periodic lab screenings.</br></br>The Youtopia app will track all your progress and send reminders when it's time to retest."
      }
    },
    "Ready_To_Start": "I'm Ready to Start",
    "Learn_More": "Learn More About the Discovery Center",
    "Finish_Tour": "Finish Tour"
  },
  "Learn": {
    "Title": "Learn",
    "Tab_Label": "Learn"
  },
  "Onboarding_Progress": {
    "Complete": "Complete",
    "Step": "Step"
  },
  "Daily_Progress": {
    "Today": "Today",
    "Yesterday": "Yesterday",
    "7_Day_Average": "7 Day Avg"
  },
  "Home_Progress_Header": {
    "View_Detail": "View Detail"
  },
  "User_Selector": {
    "Me": "Me",
    "Household": "Household",
    "Guest": "Guest",
    "Add_Guest": "Add a guest to this order"
  },
  "Guest_Name_Row": {
    "Rename": "Rename this guest"
  },
  "Add_Guest": {
    "Title": "Add Guest",
    "Explanation": "You can purchase food for guests joining you for a meal, we won't have data to match them to a prescriptive nutrient plan",
    "Name_Placeholder": "Name",
    "Name_Required": "Please enter a name for your guest",
    "Limit_Reached": "You've reached the maximum number of guests for this order",
    "Guests_Not_Allowed": "Guests can only be added to a Schedule & Save order",
    "Add_Guest_Error": "We couldn't add your guest. Please try again."
  },
  "Edit_Guest": {
    "Title": "Edit Guest",
    "Name_Placeholder": "Name",
    "Name_Required": "Please enter a name for your guest",
    "Remove_Link": "Remove guest from this order",
    "Rename_Error": "We couldn't rename your guest. Please try again.",
    "Confirm_Title": "Remove Guest",
    "Confirm_Message_None": "Remove {{name}} from this order?",
    "Confirm_Message_One": "Remove {{name}} from this order? The menu item selected for them will be removed too.",
    "Confirm_Message": "Remove {{name}} from this order? The {{count}} menu items selected for them will be removed too.",
    "Remove_Error": "We couldn't remove your guest. Please try again."
  },
  "Feature_List": {
    "Read_More": "Read More",
    "Read_Less": "Read Less",
    "Included": "Included",
    "Not_Included": "Not included"
  },
  "FeatureAccess": {
    "Get_Group_Memberships_Error": "Unable to load membership features. Please try again."
  },
  "Nutrient_Program": {
    "Title": "Nutrient Automation Dashboards",
    "Load_Error": "We're having trouble loading your Nutrient Automation Plan",
    "Tour_Schedule_Title": "Automate Your Optimal Weekly Nourishment",
    "Tour_Schedule_Body": "Choose \"At Home\" to receive a menu item or use \"Dine Out\" / \"No Meal\" to plan your week.",
    "Tour_Step": "{{step}}/{{total}}",
    "Tour_Selection_Health_Title": "Optimal for your Health",
    "Tour_Selection_Health_Body": "We have recommended your items based off your nutrient needs, preferences and how you've previously rated your menu items, restaurant and chef.",
    "Tour_Selection_Swap_Title": "Swapping Menu Items",
    "Tour_Selection_Swap_Body_1": "Don't like a recommendation? You can tap on a menu item and select from multiple options to meet your desires.",
    "Tour_Selection_Swap_Body_2": "As you're considering other options you'll find them somewhat rank-ordered by your preferences, ratings, and nutritional needs.",
    "Tour_Selection_Checkout_Title": "{{minutes}} Minutes to check out",
    "Tour_Selection_Checkout_Body": "Tap the plus to add items to your cart. Menu items are limited so we can only hold what you've added to your cart for {{minutes}} minutes.",
    "Tour_Delivery_Title": "Delivery for Schedule Ahead & Save",
    "Tour_Delivery_Body_1": "Our menu items maintain 5 days of freshness when properly refrigerated. For optimal freshness we want to deliver your menu items 1-2 days before your planned consumption.",
    "Tour_Delivery_Body_2": "All menu items are kept fully refrigerated. When selecting availability be prepared to move your items to your fridge to maintain freshness.",
    "Tour_Delivery_Body_3": "If you anticipate that you won't be immediately available add returnable ice packs to your order.",
    "Get_Nutrient_Program_Error": "Failed To Retrieve Nutrient Program",
    "Get_Nutrient_Results_Error": "Failed To Retrieve Nutrient Results",
    "Post_Onboarding_Error": "Failed To Complete Nutrient Program Onboarding",
    "Update_Nutrient_Program_Error": "Failed To Update Nutrient Program",
    "At_Home": "At Home",
    "Pickup": "Pickup",
    "Delivery": "Delivery",
    "Pickup_Or_Delivery": "Pickup or Delivery",
    "Dine_Out": "Dine Out",
    "No_Meal": "No Meal",
    "No_Meal_Recorded": "No item recorded",
    "Find_A_Match": "Find a Match",
    "Sold_Out": "Sorry, just sold out",
    "Add_All_Recommendations": "Add all recommendations to cart",
    "Add_All_Success_One": "Added 1 menu item to your cart",
    "Add_All_Success": "Added {{count}} menu items to your cart",
    "Add_All_None": "No menu items to add",
    "No_Schedule_Yet": "Your schedule appears here once your Nutrient Program is ready.",
    "No_Occasion": "No {{occasion}}",
    "Not_Available": "Not Available",
    "Unavailable_Date_Range": "Unavailable {{start}}-{{end}}",
    "Unavailable_Warning": "Being unavailable {{days}} days in a row will limit the amount of menu items we can recommend due to food freshness.",
    "Unavailable_Warning_Critical": "Being unavailable {{days}} days in a row leaves your household short on meals. Update your availability.",
    "Future_Options": "Future options will appear each day.",
    "Select_Meal": "Select Item",
    "Add_Meal": "Add Item",
    "Rate_Meal": "Rate This Item",
    "Editing_In_Progress_Title": "{{name}} is editing right now",
    "Editing_In_Progress_Body": "Only one household member can edit at a time. You can make changes once {{name}} is done.",
    "Editing_Fallback_Name": "Another household member",
    "On_Demand_Orders": "On Demand Orders",
    "Schedule_Ahead_And_Save": "Schedule Ahead and Save",
    "Items_Successfully_Purchased": "Items Successfully Purchased",
    "Num_Of_Num_Purchased": "{{num1}} of {{num2}} Purchased",
    "Num_Of_Num_In_Cart": "{{num1}} of {{num2}} In Cart",
    "Day": "Day",
    "Schedule_Info_Title": "Update Schedule",
    "Schedule_Info_Body": "Tell us when you or a household member are planning on dining out, skipping a meal, or eating at home. We'll recommend menu items when you're eating at home in a future step.",
    "Schedule_Info_Edit_Defaults": "Edit Defaults",
    "Schedule_Info_How_It_Works": "How it Works",
    "Selection_Info_Title": "Selection",
    "Selection_Info_Checkout_Title": "{{minutes}} Minutes to checkout",
    "Selection_Info_Checkout_Body": "When you tap the plus to add items to your cart we'll hold it for {{minutes}} minutes, since menu items are limited. Swap anything you want before you start adding.",
    "Selection_Info_Swap_Title": "Swapping menu items",
    "Selection_Info_Swap_Body": "Tap anywhere except the plus to view your recommended menu item and see details or swap to another recommendation.",
    "Selection_Info_Edit_Price_Range": "Edit Price Range",
    "Selection_Info_How_It_Works": "How it Works",
    "On_Demand_Info_Title": "On demand orders",
    "On_Demand_Info_Body": "Haven't automated with Schedule Ahead & Save? No worries, you can order on demand for the next three days to make sure your nutritional needs are met.",
    "On_Demand_Info_Action": "Place On Demand Order",
    "Schedule_Ahead_Info_Title": "Schedule Ahead & Save",
    "Schedule_Ahead_Info_Body": "Tell us your schedule, when you want your items delivered and pick from an array of recommended menu items to automate getting and staying healthy the easy way.",
    "Schedule_Ahead_Info_Action": "Update Household Preferences",
    "Delivery_Info_Title": "Delivery Schedule",
    "Delivery_Info_Body_1": "You'll get your menu items 1-2 days before you'll eat them. If you're unavailable for more than 2 days we'll limit your recommendations to menu items with a longer shelf life.",
    "Delivery_Info_Body_2": "You can also add ice when checking out if you won't be available for the whole delivery window.",
    "Delivery_Info_Edit_Defaults": "Edit Defaults",
    "Delivery_Info_How_It_Works": "How it Works",
    "History": "History",
    "History_Info_Title": "History",
    "History_Info_Body": "View your past item selections and nutrient scores. Past items cannot be modified.",
    "Ratings_Info_Title": "Ratings",
    "Ratings_Info_Body_1": "Rate the menu items your household has received. The more you rate, the better we learn everyone's tastes — and the sharper your future recommendations get.",
    "Ratings_Info_Body_2": "The score beside each day shows how well those items matched your household's nutrition goals. Tap any item to leave a rating.",
    "Order_By": "Order by {{time}}",
    "Cutoff_Passed": "The order cutoff for this day has passed",
    "New_Recommendation": "New pick for you"
  },
  "Update_Schedule": {
    "Title": "Schedule",
    "Subtitle": "Choose \"At Home\" for Schedule Ahead & Save."
  },
  "Delivery_Availability": {
    "Title": "Delivery",
    "Subtitle": "Select when your household is available to receive your Schedule Ahead & Save orders.",
    "Window_Full": "{{window}} delivery window is full, please choose another delivery window",
    "Day_Already_Scheduled": "You already have a delivery scheduled this day",
    "Removed_Full_Single": "Your {{window}} delivery on {{day}} filled up and was removed.",
    "Removed_Full_Multiple": "{{count}} delivery windows filled up and were removed from your preferences."
  },
  "Food_Selection": {
    "Title": "Selection",
    "Subtitle": "Tap plus to add menu items to your cart or anywhere else to swap recommendations."
  },
  "Purchase": {
    "Title": "Purchase"
  },
  "Orders": {
    "Title": "Orders"
  },
  "Nutrient_Results": {
    "Title": "Nutrient Results",
    "Today": "TODAY",
    "Load_Error": "We couldn't load your nutrient results.",
    "No_Results": "No nutrient results yet. Once you've enjoyed some meals, your results will show up here.",
    "No_Meals": "No items",
    "Not_Scored": "Not scored",
    "Categories": {
      "N2MIN": "Nutrients to Minimize",
      "CDEN": "Critical Daily Essential Nutrients",
      "CDENProtein": "Protein",
      "CDENFiber": "Fiber",
      "CDENVitaminsAndMinerals": "Vitamins & Minerals",
      "CDENOmega3": "Omega-3s",
      "RDEN": "Required Daily Essential Nutrients",
      "RDEBN": "Required Daily Energy & Balance Needs",
      "Water": "Water"
    },
    "Category_Descriptions": {
      "N2MIN": "Nutrients to minimize are the ones to keep below your personal limit, like sodium, added sugar, and saturated fat. Staying under your limit supports long-term heart and metabolic health.",
      "CDEN": "Critical daily essentials are the nutrients your body depends on every day, like protein, fiber, and key vitamins and minerals. Consistently hitting your targets here has the biggest impact on how you feel.",
      "CDENProtein": "Protein is a critical daily essential. It builds and repairs muscle, keeps you full, and steadies your energy, so reaching your daily protein target has one of the biggest effects on how you feel.",
      "CDENFiber": "Fiber is a critical daily essential that supports digestion, steadies blood sugar, and helps keep cholesterol in check. Most people fall short, so reaching your target here pays off quickly.",
      "CDENVitaminsAndMinerals": "Vitamins and minerals are the critical daily essentials your body depends on every day, from iron and calcium to vitamins A, C, and D. Consistently hitting these targets keeps your energy, immunity, and focus steady.",
      "CDENOmega3": "Omega-3 fats are critical daily essentials that support heart, brain, and joint health and help keep inflammation in check. They come mostly from fish, nuts, and seeds, so they take deliberate choices to reach.",
      "RDEN": "Required daily essentials round out your nutrient needs with the vitamins and minerals that keep your body's systems running smoothly over time.",
      "RDEBN": "Energy and balance needs track your overall fuel, calories and the balance of protein, fat, and carbohydrates, against what your body needs each day.",
      "Water": "Water tracks your hydration from food and drink against what your body needs each day. Staying hydrated supports energy, digestion, and focus."
    }
  },
  "Experience_Results": {
    "Last_Tested": "Last Tested: {{date}}",
    "Overall_Score": "Overall Score",
    "Expires": "Expires: {{date}}",
    "Starting_Line": {
      "Name": "The Starting Line™"
    },
    "Optimal": {
      "Title": "Optimal",
      "Label": "Your results indicate you are progressing toward optimal health.",
      "Description": "Congratulations on your progress towards optimizing your health! Your results have been reviewed by Youtopia’s medical and nutritional team. Based on those results, we have fine-tuned your Personal Nutrient Score™ on Youtopia’s entrees and consumables to continue supporting your health and wellness journey."
    },
    "Needs_Improvement": {
      "Title": "Needs Improvement",
      "Label": "Your results indicate you have item(s) that need improvement.",
      "Description": "Your results have been reviewed by Youtopia’s medical and nutritional team. Based on those results, we have adjusted your Personal Nutrient Score™ on Youtopia’s entrees and consumables to indicate which of these will most likely help improve your results and health."
    },
    "Needs_Medical_Review": {
      "Title": "Needs Medical Review",
      "Label": "Your results indicate you have item(s) that need medical review.",
      "Description": "If you have not already been notified by our affiliated medical team at MaxWell Clinic or taken action with your personal clinician, Youtopia can help you understand the next steps."
    },
    "Needs_Medical_Attention": {
      "Title": "Needs Medical Attention",
      "Label": "Your results indicate you have item(s) that need medical attention soon.",
      "Description": "If you have not already been notified by our affiliated medical team at MaxWell Clinic or taken action with your personal clinician, Youtopia can help you understand the next steps."
    },
    "Immunity": {
      "Name": "Immunity",
      "Quote": "<i>“Physical touch makes you healthier. Hugs, massages, and holding hands reduces stress while boosting your immune system.” --Unknown</i>",
      "Info": "<div><b>Why is Immunity Important?</b></div><br>It is important to measure the body’s ability to protect itself from getting sick and monitor the body’s ability to overcome viruses and help to eliminate any infections. Research has proven that providing the body with organic sourced highly nutrient-dense meals that contain nutrients like vitamins B, C, D, flavonoids, L-theanine, fiber, protein, antioxidants and beta-glucans and other bioactive molecules that fight harmful bacteria, viruses, and eliminates toxins will help to strengthen your immune system. In addition, do your best to avoid using a lot of sugar, salt, and eating foods high in trans-fat which tend to weaken the immune system.",
      "Improve_Suggestions": "<div><b>Ideas to Build a Powerful Immune System</b></div><br>*\tEnjoy sunshine for 20 minutes on exposed skin as this produces T-cells (a major part of the immune system) that help differentiate between harmful cells and your own cells.<br>*\tEnjoy citrus foods, bell peppers, and tomatoes found in Youtopia’s nourishment because they help to increase the production of white blood cells.<br>*\tEnjoy a snack of oysters occasionally, because they are so good for the immune system with 59 trace elements, 12 vitamins, 19 amino acids and omega 3 fatty-acids.<br>*\tEnjoy a cup of green tea because it contains flavonoids and L-theanine that aid in the production of germ-fighting compounds in T-Cells (a major part of the immune system).<br>*\tEnjoy all types of mushrooms as these contain B vitamins, minerals, fiber, protein, antioxidants, and beta-glucans and other bioactive molecules that fight harmful bacteria, viruses, and toxins.<br>*\tEnjoy garlic as it contains allicin which is responsible for its antibacterial and antiviral properties. It also helps to raise antioxidants that help to destroy bacteria and viruses.<br>*\tEnjoy colostrum found in mother’s milk and in goat’s milk. This contains cytokines, which are part of your systemic immune system.<br>*\tEnjoy sleeping as lack of sleep not only robs you of energy and productivity, but it also elevates inflammation that will cause an immune response.<br>*\tYoutopia entrees use a rainbow of colors. Research has shown that colorful nourishment is a wonderful way to boost your immune health and could add years to your life.<br>*\tYoutopia entreesare high in nutrients, portion controlled, and follow an anti-inflammatory nourishment to support the immune system.<br>*\tEnjoy entrees and consumables that contain probiotics such as kombucha for a snack or select entrees from Youtopia that contain unpasteurized sauerkraut and kimchi, tofu, miso, natto, tamari, and tempeh.<br>*\tYoutopia entrees are seasonal. It is an Indian practice of ayurveda called ritucharya. The concept of ritucharya breaks down what to eat during each season to maintain immune health.<br>*\tYoutopia meals include omega6 and omega3 healthy fats at a healthy ratio. “A lower ratio of Omega 6/Omega 3 fatty-acids is more desirable in reducing the risk of many chronic diseases of high prevalence in Western societies.” Western diets are a 16:1 ratio of Omega 6 fatty-acids to Omega 3 fatty-acids and this promotes the pathogenesis of many diseases, including cardiovascular disease, cancer, inflammatory and autoimmune diseases.",
      "Avoid_Suggestions": "<div><b>Avoid These Immunity Destroyers</b></div><br>*\tTry to avoid added sugar found in bread and baked products because high blood sugar may inhibit the response of immune cells to help protect against infection.<br>*\tTry to avoid high salt foods like chips, processed foods, and fast food because they inhibit normal immune function.<br>*\tTry to avoid eating too many Omegas 6 fatty acids because eating too elevated levels of Omega 6 can increase pro-inflammatory proteins and weaken immune system.Foods to avoid are processed snacks, chips, fast food, and hydrogenated oils.<br>*\tTry to avoid eating processed meats or charred meats as they contribute to immune dysfunction.<br>*\tTry to avoid artificially sweetened foods and beverages because it alters gut bacteria and blunts immune response."
    },
    "Heart_And_Vascular": {
      "Name": "Heart and Vascular",
      "Quote": "<i>“No beauty shines brighter than a healthy heart!” “If my mind can conceive it, if my heart can believe it, then I can achieve it.” – Muhammed Ali</i>",
      "Info": "<div><b>Heart & Vascular</b></div><br> According to the American Heart Association.<br><br>*\tThe amount of people who died globally from cardiovascular disease were 19.05 million.<br>*\tEvery 40 seconds, someone in the United States will have myocardial infarction.<br>*\tThe estimated cost of heart disease in 2017 to 2018 was $228.7 billion (about $700 per person in the US)<br>*\tIn 2019 strokes accounted for approximately 1 of every 19 deaths in the United States. The heart is central to overall good health, it is vital for everything that gives your body life. It pumps nutrient-rich blood throughout the body, supplies oxygen while removing toxins and waste, and maintains the immune system. Current scientific evidence shows that there is an intimate relationship between nutrition and cardiovascular disease. The evidence favors consumption of healthy dietary patterns, such as eating polyphenols (fruit, vegetables, red wine, black and green tea, coffee, dark chocolate, nuts, and seeds), healthy fats (fish, olive oil, seeds, and flaxseed oil), high fiber (fruits, vegetables, and grains). When you eat high quality nutrient-dense foods you not only nourish your body, you also will feel happiness and peace of mind that you are taking diligent care of yourself.<br><br>The Truth About Cholesterol<br><br>Not all cholesterol is bad. HDL cholesterol is important to the body. It is needed to make hormones and cell membranes that create healthy cells which build up body structure and aid in nutrient absorption. In addition, it transports cholesterol and other fatty acids from the liver to the peripheral tissues for uptake and metabolism by the cells.<br> However, too much LDL cholesterol that is obtained through trans-fat (fried food, processed foods), and elevated levels of saturated fat (more than 10% of daily diet) can clog arteries that are needed to move nutrients in blood and supply oxygen to cells.",
      "Improve_Suggestions": "Ideas to Pump Up the Heart   <br>*\tEnjoy supporting heart health by eating Youtopia’s portion-controlled high fiber nourishment. Fiber helps to lower total blood cholesterol levels by lowering LDL (bad cholesterol) levels.<span style=\"color:red;\">51</span>   <br>*\tYoutopia uses cold-pressed expelled organic oil for all our high heat cooking.<span style=\"color:red;\">52</span>   Youtopia never uses any hydrogenated vegetable oils, these are bad for the heart and vascular health.<span style=\"color:red;\">53</span>  <br>*\tYoutopia uses olive oil, walnut oil, flaxseed oil, avocado oil for dressings, sauces, and marinades. When we use any of these healthy oils for cooking, we cook them at a low temperature. Cooking these unrefined oils at too high a temperature destroys beneficial nutrients and phytochemicals that help support the heart and vascular system.<span style=\"color:red;\">54</span>  <br>*\tDrinking water throughout the day supports heart health. When the body is well hydrated the heart can pump blood through the body more efficiently and reduce strain on this important muscle.  <br>*\tYoutopia entreesare a rainbow of colors, high in nutrients, and follow an anti-inflammatory plan.<span style=\"color:red;\">55</span>  <br>*\tYoutopia meals include omega6 and omega3 healthy fats at a healthy ratio.  “A lower ratio of Omega 6/Omega 3 fatty-acids is more desirable in reducing the risk of many chronic diseases of high prevalence in Western societies.” <span style=\"color:red;\">214</span>   Western diets are a 16:1 ratio of Omega 6 fatty-acids to Omega 3 fatty-acids and this promotes the pathogenesis of many diseases, including cardiovascular disease, cancer, inflammatory and autoimmune diseases.<span style=\"color:red;\">56</span>   <br>*\tParticipate in intentional exercise (brisk walking, running, swimming, cycling, playing tennis, and jumping rope) at least 150 minutes (about 2 and a half hours) per week.<span style=\"color:red;\">57</span>",
      "Avoid_Suggestions": "<div><b>Avoid These Heart Breakers </b></div><br><br>*\tTry to avoid eating foods high in trans-fats such as fried foods and foods cooked in vegetable oils, that most fast food and other restaurants use. Also, try to avoid processed foods, sugary cereals, chips, cookies, pastries, margarine, processed and cured meats all loaded with trans-fats.  <br>*\tAvoid smoking and any use of tobacco. Tabacco kills more than 8 million people each year. More than 7 million of those deaths are the result of direct tobacco use while around 1.2 million are the result of non-smokers being exposed to secondhand smoke.<span style=\"color:red;\">58</span>   <br>*\tAvoid overeating by eating portion-controlled entreesthat Youtopia entrees provide.   <br>*\t      Avoid simple carbohydrates found in bread, pasta, and baked goods.  Excessive simple carbohydrates turns into saturated fat that can raise total cholesterol and LDL cholesterol levels."
    },
    "Prediabetic_Indicators": {
      "Name": "Prediabetic Indicators",
      "Quote": "<i>37.3 million (about 1 in 10) Americans struggle with diabetes, about 1 in 5 have diabetes and do not know they have it. Another 96 million have prediabetes.It is the seventh leading cause of death in the US and cost an estimated $327 billion (about $1,000 per person in the US) in medical costs and lost work and wages. 61     “Always remember you are braver than you believe, stronger than you seem, smarter than you think and loved more than you know.” – A.A. Milne</i>",
      "Info": "<div><b>Prediabetic Indicators </b></div><br>  Blood sugar monitoring is needed to find out if blood glucose levels are within the target range. If glucose gets too low, you can lose the ability to think or function normally. If it is too high, it can cause damage to the body over many years and lead to diabetes. Diet changes and weight loss are the best ways to maintain blood sugar levels and reverse pre-diabetes or diabetes. This does not mean that you will be cured of diabetes, but you can possibility put diabetes in remission.If unmanaged Type 2 diabetes may lead to blindness, kidney failure, heart disease, joint pain, skin rotting, and other serious conditions.<span style=\"color:red;\">63</span>",
      "Improve_Suggestions": "Ideas for Controlling Prediabetes    <br>*\tYoutopia entrees and consumables offer simple carbohydrates such as fresh vegetables, whole fruit, and healthy grains which support blood sugar levels.<span style=\"color:red;\">64</span>   <br>*\tEnjoy Youtopia entrees with lean proteins such as fish, nuts, and seeds.<span style=\"color:red;\">65</span>   <br>*\tEnjoy supporting the reduction of inflammation by eating Youtopia’s portion-controlled high fiber nourishment. The American Heart Association suggests 25 to 30g of fiber a day.<span style=\"color:red;\">66</span> Youtopia entrees are typically targeted to provide 20g to 40g of fiber daily.   <br>*\tYoutopia entreesand consumables are high in nutrients, portion controlled, and follow anti-inflammatory nourishment to support prediabetes and diabetes.<span style=\"color:red;\">67</span>  <br>*\tYoutopia entrees are seasonal. It is an Indian practice of ayurveda called ritucharya. The concept of ritucharya breaks down what to eat during each season to maintain health and prevent disease. <span style=\"color:red;\">68</span>  <br>*\tYoutopia meals include omega6 and omega3 healthy fats at a healthy ratio. “A lower ratio of Omega 6/Omega 3 fatty-acids is more desirable in reducing the risk of many chronic diseases of high prevalence in Western societies.” <span style=\"color:red;\">214</span>   Western diets are a 16:1 ratio of Omega 6 fatty-acids to Omega 3 fatty-acids and this promotes the pathogenesis of many diseases, including cardiovascular disease, cancer, inflammatory and autoimmune diseases.<span style=\"color:red;\">69</span>   <br>*\tTo help control diabetes, Youtopia is selective in the type of oils we use in our cooking. We use organic, cold-pressed, expelled, non-GMO oil for all our high heat cooking.<span style=\"color:red;\">70</span>  <br>*\tYoutopia uses olive oil, walnut oil, flaxseed oil, avocado oil for dressings, sauces, and marinades. When we use any of these healthy oils for cooking, we cook them at a low temperature. Cooking these unrefined oils at too high a temperature destroys beneficial nutrients and phytochemicals found in these healthy oils.<span style=\"color:red;\">71</span>     Other Tips to Try  <br>*\tEnjoy exercising 30 minutes a day 5 days a week. Exercise increases the insulin sensitivity of your cells, meaning that you need less insulin to manage blood sugar levels.<span style=\"color:red;\">72</span>   <br>*\tEnjoy drinking water and make it your primary drinking beverage.Youtopia has filtered water that you can fill your water bottle anytime.  <br>*\tGet plenty of sleep. Decreased sleep is a risk factor for increased blood sugar levels. Even partial sleep deprivation over one night increases insulin resistance, which can increase blood sugar levels. As a result, lack of sleep has been associated with diabetes.<span style=\"color:red;\">73</span>",
      "Avoid_Suggestions": "Avoid these Pungent Candi-Coated Gems   <br>*\tDo your best to avoid eating refined carbohydrates like soda, candy, desserts, white bread, pasta, and sweetened cereal.  <br>*\tDo your best to avoid eating processed foods, especially those with added sugar, unhealthy fats, and chemical preservations.  <br>*\tDo your best to avoid drinking soda and sweetened fruit juice and drink lots of water.  <br>*\tAvoid cigarette smoking and other tobacco products, they may increase insulin resistance. Tabacco kills more than 8 million people each year. More than 7 million of those deaths are the result of direct tobacco use while around 1.2 million are the result of non-smokers being exposed to secondhand smoke.<span style=\"color:red;\">74</span>   <br>*\tDo your best to avoid excessive portion sizes in meals.Youtopia meals are all portion controlled.  <br>*\tDo your best to avoid sitting most of the day with little physical activity."
    },
    "White_Blood_Cells": {
      "Name": "White Blood Cells",
      "Test_Message": "This test measures the number of white blood cells that move through blood and tissue looking for foreign invaders such as bacteria, viruses, parasites, and fungi. When these cells counts are low it causes inflammation, and the immune system weakens. An elevated level usually indicates that an infection is present in the body but may also be caused by lifestyle factors such as strenuous exercise and eating too many refined carbohydrates and sugar. To help maintain proper white blood cell levels, Youtopia takes great care to offer entrees and consumables that are anti-inflammatory and contain immune-boosting nutrients that include Omega 3 fatty-acids, beta carotene, vitamins C and D, zinc, probiotics, and protein. Youtopias entrees and consumables do not have commercial baked goods, processed foods, artificial sweeteners and other chemical additives, and trans-fats all which contribute to poor white blood cell levels. In addition, allergens like wheat, dairy, and soy (that can also affect white blood cell count) are reduced or eliminated."
    },
    "Globulin": {
      "Name": "Globulin",
      "Test_Message": "Measures protein absorption and if low could mean malnutrition. To help maintain proper globulin levels Youtopia takes great care to increase high quality lean proteins and soluble fiber and offer low glycemic and low starch vegetables. Entrees and consumables have no refined carbohydrates (found in processed foods) or high-fructose corn syrup as both contribute to poor globulin levels."
    },
    "Experience_Progress": "Experience Progress",
    "Category_Score_Breakdown": "Category Score Breakdown",
    "Category_Score_Breakdown_Description": "Your Overall Score represents a blend of scores across a number of wellness categories. Tap into each category to learn more about your specific results.",
    "No_Categories": "No Categories",
    "View_Detailed_Results": "View Detailed Results",
    "Category_Progress": "Category Progress",
    "View_More": "View More",
    "View_Less": "View Less",
    "Detailed_Results": "Detailed Results",
    "Detailed_Analyte_Results": "Detailed Analyte Results",
    "Detailed_Analyte_Results_Description": "Testing the following analytes helps provide an understanding of your wellness as it relates to the selected category. Tap into each analyte for additional information and insights.",
    "Analytes": "Analytes",
    "Your_Results": "Your Results",
    "No_Analytes": "No Analytes",
    "No_Ranges": "No Ranges",
    "Why_Is_This_Test_Important": "Why is this test important?",
    "Analyte_Progress": "Analyte Progress"
  },
  "Membership_Package": {
    "Essential": {
      "Name": "Essential",
      "Title": "Essential Precision"
    },
    "Optimized": {
      "Name": "Optimized",
      "Title": "Optimized Precision"
    },
    "Feature": {
      "Phenotype_Data": "Survey-Based Phenotype Data",
      "Biometric_Matching": "Biometric Based Matching",
      "Health_Matching": "Health Matching",
      "Clean_Ingredient_Guidelines": "Meets Our Clean Ingredient Guidelines",
      "Starting_Line": "The Starting Line",
      "Vitamin_And_Mineral_Optimizer": "Vitamin & Mineral Optimizer"
    }
  },
  "Dine_Out_Event": {
    "Create_Event": "Create Event",
    "Modify_Event": "Modify Event",
    "Modify": "Modify",
    "Im_Here": "I'm Here",
    "Location": "Location",
    "Occasion": "Occasion",
    "When": "When",
    "Change": "Change",
    "Dining_With": "Dining With",
    "Select_Attendee": "Add at least one person dining to continue.",
    "Future_Time_Required": "Pick a start time in the future.",
    "Breakfast": "Breakfast",
    "Lunch": "Lunch",
    "Dinner": "Dinner",
    "Save_Changes": "Save Changes",
    "Back_To_Home": "Back to Home",
    "Info_Text": "We will text you with your Youtopia certified menu items when you are near your dining location.",
    "Created_Successfully": "Event created successfully",
    "Updated_Successfully": "Event updated successfully",
    "Cancelled_Successfully": "Event cancelled successfully",
    "Create_Error": "Failed to create event",
    "Update_Error": "Failed to update event",
    "Cancel_Error": "Failed to cancel event",
    "Rsvp_Error": "Failed to update RSVP",
    "Error_No_Attendees": "Add at least one person dining to this event.",
    "Error_Invitee_Not_Member": "You can only invite current household members.",
    "Error_Invalid_Schedule": "Pick a start time in the future.",
    "Error_Invalid_Occasion": "Dine-out events are for breakfast, lunch, or dinner.",
    "Error_Event_Closed": "This event has already started and can no longer be changed.",
    "Error_Stale_Version": "This event changed since you opened it. Reopen it and try again.",
    "Error_Stale_Revision": "This event changed since you opened it. Reopen it and try again.",
    "Error_Not_Creator": "Only the event's creator can change it.",
    "Error_Venue_Not_Found": "We couldn't find that restaurant.",
    "Venue_Ineligible_Title": "This restaurant can't host a dine-out event",
    "Venue_Ineligible_Producer_Not_Active": "It isn't accepting dine-out events right now.",
    "Venue_Ineligible_Not_Offered": "It doesn't offer dine-in.",
    "Venue_Ineligible_No_Menu": "It has no menu items available yet.",
    "Venue_Ineligible_Fallback": "Please choose another restaurant.",
    "Event_Details": "Event Details",
    "Accept": "Accept",
    "Decline": "Decline",
    "RSVP": "RSVP",
    "Change_Rsvp": "Change RSVP",
    "Rsvp_You_Accepted": "You accepted",
    "Rsvp_You_Declined": "You declined",
    "Rsvp_Accepted_Successfully": "Event Accepted Successfully",
    "Rsvp_Declined_Successfully": "Event Declined Successfully",
    "Rsvp_Pending": "Pending",
    "Rsvp_Accepted": "Going",
    "Rsvp_Declined": "Not Going",
    "Cancel_Event": "Cancel Event",
    "Cancel_Confirm": "Cancel Event",
    "Cancel_Confirm_Message": "Are you sure you want to cancel this dining event? Everyone invited will be notified.",
    "Get_Error": "Failed to retrieve event",
    "All_Dining_Events": "Dining Events",
    "No_Upcoming_Events": "No Upcoming Dining Events",
    "No_Dining_Events": "No dining events yet"
  },
  "Dine_Out_Menu": {
    "Title": "Confirm your Meal",
    "Select_Meal_Size": "Select Meal Size",
    "Select_Meal": "Select Meal",
    "Confirm_Ordered_Items": "Confirm Ordered Items",
    "Confirmed_Successfully": "Your meal has been recorded",
    "Record_Meal_Error": "We couldn't record your meal. Please try again."
  },
  "Order_Type_Label": {
    "delivery": "Delivery",
    "pickup": "Pickup",
    "dineout": "Dine Out",
    "scheduleAndSave": "Schedule And Save"
  },
  "Eating_Occasion_Label": {
    "Other": "Other",
    "Breakfast": "Breakfast",
    "Lunch": "Lunch",
    "Dinner": "Dinner",
    "Snack": "Snack",
    "Dessert": "Dessert",
    "Beverage": "Beverage"
  },
  "Portion_Size_Label": {
    "Extra_Small": "Extra Small",
    "Small": "Small",
    "Medium": "Medium",
    "Large": "Large",
    "Extra_Large": "Extra Large"
  },
  "Portion_Size_Abbreviation_Label": {
    "Xs": "XS",
    "S": "S",
    "M": "M",
    "L": "L",
    "Xl": "XL"
  },
  "Portion_Size_Abbreviation_Full_Label": {
    "Xs": "Extra Small",
    "S": "Small",
    "M": "Medium",
    "L": "Large",
    "Xl": "Extra Large"
  },
  "Invitation_Status_Label": {
    "Pending": "Pending",
    "Accepted": "Accepted",
    "Declined": "Declined",
    "Expired": "Expired"
  },
  "Score_Card": {
    "Personalized_Score": "{{name}}'s Personalized Nutrient Score™",
    "Score_Label": "{{name}}'s Score",
    "Info_Title": "Your Nutrient Score",
    "Info_Body": "Your personalized nutrient score is calculated based on your unique health profile and dietary needs."
  },
  "Personal_Score": {
    "POOR": "Poor",
    "OKAY": "Okay",
    "GOOD": "Good",
    "BEST": "Best",
    "AVOID": "Avoid",
    "OPTIMAL": "Optimal",
    "FAIR": "Fair",
    "For_Your_Nutrient_Needs": "For Your Nutrient Needs",
    "For_Others_Similar_To_You": "For Others Similar To You",
    "No_Data": "?-?"
  },
  "Day_Score": {
    "Add_Meals": "Add Items",
    "As_Suggested": "As Suggested",
    "Your_Selections": "Your Selections"
  },
  "Location": {
    "Location_Permission": "Location Permission",
    "Location_Warning": "You did not allow Youtopia to access the location. It is required to enable Youtopia features."
  },
  "Network": {
    "Network_Status": "Network Status",
    "Network_Connected": "Network Connected",
    "Network_Disconnected": "Network Disconnected"
  },
  "Account": {
    "Get_Account_Error": "Failed To Retrieve Account",
    "Account_Exists_Error": "Failed To Check Account Existence",
    "Get_Account_Memberships_Error": "Failed To Retrieve Account Memberships",
    "Get_Account_Packages_Error": "Failed To Retrieve Account Packages",
    "Get_Available_Packages_Error": "Failed To Retrieve Available Packages",
    "Get_Available_Options_Error": "Failed To Retrieve Available Options",
    "Get_Household_Discount_Error": "Failed To Retrieve Household Member Discount",
    "Purchase_Packages_Error": "Failed To Purchase Packages For Account",
    "Update_Account_Error": "Failed To Update Account",
    "Check_Availability_Error": "Failed to check service area availability",
    "Get_Pricing_Preview_Error": "Failed To Retrieve Pricing Preview",
    "Post_Pricing_Preview_Error": "Failed To Calculate Pricing Preview",
    "Duplicate_Membership_Error": "{{email}} already has a pending invite or membership and can't be added."
  },
  "Health": {
    "Get_Experience_Error": "Failed To Retrieve Experience"
  },
  "GroupScore": {
    "Get_Error": "We couldn't load group scores right now."
  },
  "Group": {
    "Role": {
      "Admin": "Admin",
      "Owner": "Household Owner",
      "Member": "Household Member",
      "Dependent": "Dependent"
    },
    "Get_Group_Error": "Failed To Retrieve Group",
    "Set_Health_Sharing_Error": "Failed To Update Health Sharing",
    "Get_Group_Invitations_Error": "Failed To Retrieve Group Invitations",
    "Get_Invitation_Error": "Failed To Retrieve Invitation",
    "Invite_Users_To_Group_Error": "Failed To Invite Users To Group",
    "Remove_Staged_Invitation_Error": "Failed To Remove Staged Invitation",
    "Resend_Invitation_Error": "Failed to resend invitation",
    "Cancel_Invitation_Error": "Failed to cancel invitation",
    "Designate_Admin_Error": "Failed to make member an admin",
    "Revoke_Admin_Error": "Failed to remove admin access",
    "Remove_Member_Error": "Failed to remove member"
  },
  "Order": {
    "Title": "Order",
    "Get_Cart_Error": "Failed to Retrieve Cart",
    "Add_Item_To_Cart_Error": "Failed to Add Item To Cart",
    "Household_Ordering_Forbidden_Header": "Permission Needed",
    "Household_Ordering_Forbidden": "Ordering for another household member needs the household's ordering permission. You can still order for yourself.",
    "Update_Item_Cart_Quantity_Error": "Failed to Update Item Cart Quantity",
    "Delete_Item_From_Cart_Error": "Failed to Delete Item From Cart",
    "Get_Order_Line_Items_Error": "Failed to Get Order Items",
    "Add_Delivery_Details_To_Cart_Error": "Failed to Add Delivery Details Cart",
    "Clear_Cart_Error": "Failed to Clear Cart",
    "Change_Fulfillment_Type_Error": "Failed to Change Fulfillment Type",
    "Complete_Order_Error": "Failed to Complete Order",
    "Get_Delivery_Windows_Error": "Failed To Retrieve Delivery Windows",
    "Get_Orders_Error": "Failed To Retrieve Orders",
    "Get_Order_Deliveries_Error": "Failed To Retrieve Order Deliveries",
    "Update_Add_Ons_Error": "Failed To Update Your Order",
    "Add_On_Delivery_Label": "Delivery {{number}} of {{count}} · {{date}}",
    "Add_On_Included": "{{name}} included",
    "Ice_Pack_Description": "Keeps this delivery cold on the way to you.",
    "Ice_Pack_Delivery_Not_Planned": "Your order no longer includes a delivery on {{date}}, so this ice pack cannot be sent. You will not be charged for it, and you can remove it here.",
    "Ice_Pack_Out_Of_Stock": "Ice packs are unavailable for this delivery date.",
    "Ice_Pack_Unavailable": "Ice packs can no longer be added to this delivery. You can keep the one on your order and pay only if it can be supplied, or remove it now.",
    "Ice_Pack_Unavailable_For_Delivery": "Ice packs can no longer be added for {{date}}. You can keep the one on your order and pay only if it can be supplied, or remove it now.",
    "Order_Type": "Order Type",
    "Order_Location": "{{type}} Location",
    "Order_Date": "Order Date",
    "Meals": "Items",
    "Number_Of_Menu_Items": "Number of Menu Items",
    "Menu_Items_Total": "Menu Items Total",
    "Member_Discount": "Member Discount",
    "Guest_Discount": "Guest Discount",
    "Line_Discount": "{{name}} ({{percent}}%) -{{amount}}",
    "Line_Discount_Flat": "{{name}} -{{amount}}",
    "Additional_Discounts": "Additional Healthy Gourmet Kitchen Discounts",
    "Taxes": "Taxes",
    "Delivery": "Delivery",
    "Delivery_Rate": "{{count}} deliveries at {{rate}} each",
    "Delivery_Rate_One": "1 delivery at {{rate}}",
    "Free_Delivery": "Free Delivery {{used}}/{{cap}}",
    "Free_Delivery_Partial": "{{waived}} of {{count}} deliveries free, {{charged}} at {{rate}} each",
    "Free_Delivery_Partial_One": "{{waived}} of {{count}} deliveries free, 1 at {{rate}}",
    "Total": "Total",
    "No_Meals": "No Items",
    "Membership_Summary": "Membership Summary",
    "Monthly_Summary": "Monthly Summary",
    "Household_Discount": "Household discount",
    "Estimated_Tax": "Estimated tax",
    "Due_Today": "Due today",
    "Monthly_Payment": "Monthly payment",
    "Monthly_Total_Going_Forward": "Monthly total going forward",
    "Starts_Next_Cycle": "Starts next billing cycle",
    "Recurring_Starts_Next_Cycle": "Only one-time fees are charged today. Your household's new monthly total starts on your next billing cycle.",
    "Monthly_Billing_Starts_Today": "Your first month is included in today's charge. Cancel or make changes anytime.",
    "Member": "Member",
    "Guest": "Guest",
    "Guests_On_Order": "Guests: {{names}}",
    "One_Time_Fee_Description": "One-time for labs and analysis",
    "Billing_Deferred": "Billing doesn't start until your invites are accepted",
    "Cancel_Or_Make_Changes_Anytime": "Cancel or make changes anytime",
    "Cancel_Or_Make_Changes_Anytime_Description": "No commitments, no cancellation fees. Pause, change or cancel whenever.",
    "Order_Status_Progress": "Order status progress",
    "Order_Details": "Order Details",
    "Pickup_Location": "Pickup Location",
    "Delivery_Location": "Delivery Location",
    "Fulfillment_Type": {
      "Delivery": "Delivery",
      "Pickup": "Pickup",
      "DineIn": "Dine In",
      "DineOut": "Dine Out",
      "ScheduleAndSave": "Schedule & Save"
    },
    "Pick_Up_Date": "Pick up: {{date}}",
    "Declined_Message": "{{establishmentName}} couldn't complete your order. Your card will be refunded in 3-5 business days.",
    "Declined_Message_Generic": "Your order couldn't be completed. Your card will be refunded in 3-5 business days.",
    "Place_Another_Order": "Place Another Order",
    "Contact_Support": "Contact support@youtopia.com for any order questions or concerns.",
    "Revalidate_Cart_Error": "We could not recheck your cart. Some items may no longer be available."
  },
  "Cart_Reservation": {
    "Min": "Min",
    "Min_Left_To_Checkout": "min left to checkout",
    "Savings_Title": "Congrats you've saved",
    "Savings_Detail": "{{selected}} on selected items and {{purchased}} on purchased items.",
    "Info_Title": "{{minutes}} minutes to check out",
    "Info_Body": "Menu items are limited, so we can only hold what you've added to your cart for {{minutes}} minutes. Check out before the timer runs out to keep your selections — and if you need more time, you can extend the hold.",
    "Extend_Prompt": "The items in your cart are about to expire. Would you like to add time to finish your selections?",
    "Extend_Cancel": "Cancel",
    "Extend_Minutes": "{{minutes}} Minutes",
    "Extend_Success": "We've extended your cart hold.",
    "Extend_Error": "We couldn't extend your cart hold. Please try again.",
    "Restore_Error": "We couldn't restore your cart. Please try again.",
    "Restore_Lost": "We couldn't bring back your expired cart. Please add your items again.",
    "Restore_Forbidden": "Your expired cart has items for someone you don't have permission to order for. Ask the household owner to restore it, or start fresh.",
    "Restore_Cart_Not_Empty": "You've already started a new cart, so we kept that one.",
    "Not_Restored_Title": "Some items couldn't be restored",
    "Not_Restored_Cutoff_Passed": "The ordering deadline passed for {{items}}, so it wasn't added back. You can still order on demand for that day.",
    "Not_Restored_Pulled_From_Menu": "{{items}} is no longer offered for Schedule & Save, so it wasn't added back.",
    "Not_Restored_Stock_Not_Available": "{{items}} sold out while your cart was expired, so it wasn't added back.",
    "Not_Restored_Cannot_Be_Readded": "{{items}} couldn't be added back. You can add it again at checkout once your deliveries are chosen.",
    "Expired_Title": "Your cart has expired",
    "Expired_Body": "When you come back your cart will be updated to reflect the items that are still available.",
    "Expired_Continue": "Continue Selections Now",
    "Expired_Leave": "Leave"
  },
  "Cart_Revalidation": {
    "Add_Blocked_Title": "Can't Add This Item",
    "Add_Blocked_Cutoff_Passed": "The ordering deadline for that day has passed. This item is still available to order On Demand for that day.",
    "Add_Blocked_Stock_Not_Available": "This item has sold out for the day you chose. Try another item, or choose a different day.",
    "Items_Removed_Title": "Your cart changed",
    "Removed_Cutoff_Passed": "The ordering deadline passed for {{items}}, so it was removed from your cart. Pick something else or order on demand for that day.",
    "Removed_Pulled_From_Menu": "{{items}} is no longer offered for Schedule & Save, so it was removed from your cart. We have a new recommendation for you.",
    "Removed_Stock_Not_Available": "{{items}} is no longer available, so it was removed from your cart. We have a new recommendation for you.",
    "Removed_Cannot_Be_Readded": "{{items}} couldn't stay in your cart, so it was removed."
  },
  "Entitlement": {
    "Get_Entitlements_Error": "Failed To Retrieve Entitlements"
  },
  "Review": {
    "Title": "Review your item",
    "Item_Details": "Item Details",
    "Quality_Prompt": "Please share with the Head Chef how would you rate the taste, presentation, and overall quality of this item.",
    "Quality_Poor": "Poor",
    "Quality_Exceptional": "Exceptional",
    "Frequency_Prompt": "Please share how often you would like to enjoy this item again.",
    "Frequency_Never": "Never",
    "Frequency_Occasionally": "Occasionally",
    "Frequency_Often": "Often",
    "Experience_Prompt": "Please select any of the following that would help us better understand your eating experience.",
    "Submit_Feedback": "Submit Feedback",
    "Submit_Success": "Thank you for your feedback!",
    "Submit_Error": "Failed to submit review",
    "Get_Qualities_Error": "Failed to load quality options",
    "Get_Ratings_Error": "Failed to load ratings",
    "Get_Consumable_Ratings_Error": "Failed to load consumable ratings",
    "Get_Pending_Reviews_Error": "Failed to load pending reviews",
    "Get_Bulk_Ratings_Error": "Failed to load ratings",
    "Get_Establishment_Rating_Error": "Failed to load establishment rating",
    "Get_Chef_Rating_Error": "Failed to load chef rating",
    "Rate": "Rate",
    "Rating_Required": "Please provide a quality rating before submitting.",
    "Quality_Satisfied": "Satisfied",
    "Quality_Energized": "Energized",
    "Quality_Comforted": "Comforted",
    "Quality_Delighted": "Delighted",
    "Quality_Refreshed": "Refreshed",
    "Quality_Indulgent": "Indulgent",
    "Quality_Satiated": "Satiated",
    "Quality_Inspired": "Inspired",
    "Quality_Nostalgic": "Nostalgic",
    "Quality_Overwhelmed": "Overwhelmed",
    "Quality_Unsatisfactory": "Unsatisfactory",
    "Quality_Greasy": "Greasy",
    "Quality_Overcooked": "Overcooked",
    "Quality_Undercooked": "Undercooked",
    "Quality_Bland": "Bland",
    "Quality_Too_Salty": "Too Salty",
    "Quality_Too_Sweet": "Too Sweet",
    "Quality_Too_Spicy": "Too Spicy",
    "Quality_Unfresh": "Unfresh",
    "Quality_Disappointing": "Disappointing",
    "Quality_Food_Quality_Issues": "Food Quality Issues",
    "Quality_Portion_Size_Issues": "Portion Size Issues"
  },
  "User": {
    "Get_External_User_Error": "Failed To Retrieve External User",
    "Get_User_Error": "Failed To Retrieve User",
    "Get_User_Invitations_Error": "Failed To Retrieve User Invitations",
    "Update_User_Error": "Failed To Update User",
    "Signup_Minimum_Age_Error": "You must be at least {{age}} years old to join Youtopia.",
    "Dob_Too_Old_Error": "Please enter a valid date of birth — it can't be more than {{maxAge}} years ago.",
    "Dob_Future_Error": "Your date of birth can't be in the future. Please check the date and try again.",
    "Dob_Required_Error": "Please enter your date of birth.",
    "Update_User_Fcm_Token_Error": "Failed To Update User FCM Token",
    "Delete_Fcm_Token_Error": "Failed To Delete FCM Token",
    "Get_Notification_Preferences_Error": "Failed To Retrieve Notification Preferences",
    "Update_Notification_Preferences_Error": "Failed To Update Notification Preferences",
    "Update_User_Image_Error": "Failed To Update User Image",
    "Group_Invitation": "Group Invitation",
    "Group_Invitation_Description": "You've been invited to {{name}}'s group!"
  },
  "User_Preferences": {
    "Get_Options_Error": "Failed to Load Preference Options",
    "Get_Food_Error": "Failed to Load Food Preferences",
    "Save_Food_Error": "Failed to Save Food Preferences",
    "Get_Standards_Error": "Failed to Load Ingredient Standards",
    "Save_Standards_Error": "Failed to Save Ingredient Standards",
    "Get_Dietary_Restrictions_Error": "Failed to Load Dietary Restrictions",
    "Save_Dietary_Restrictions_Error": "Failed to Save Dietary Restrictions"
  },
  "Ratings": {
    "Title": "Ratings"
  },
  "Pending_Reviews": {
    "Title": "Pending Reviews",
    "Provide_Feedback": "Provide Feedback",
    "Meals_To_Review": "You have {{count}} items to review",
    "Meals_To_Review_One": "You have 1 item to review",
    "Description": "Share your feedback to thank the chef and refine your preferences.",
    "Learn_More": "Learn More",
    "No_Pending": "No items to review right now."
  },
  "Producer": {
    "Get_Establishments_Error": "Failed To Retrieve Establishments",
    "Get_Establishment_Error": "Failed To Retrieve Establishment",
    "Get_Youtopian_Menu_Error": "Failed To Retrieve Youtopian Menu",
    "Get_Establishment_Menu_Error": "Failed To Retrieve Establishment Menu",
    "Get_Menu_Item_Details_Error": "Failed To Retrieve Menu Item Details",
    "Get_Menu_Item_Ratings_Error": "Failed To Retrieve Menu Item Ratings",
    "Get_Menu_Item_Size_Nutrient_Contents_Error": "Failed To Retrieve Menu Item Size Nutrient Contents",
    "Get_Menu_Item_Ingredients_Error": "Failed To Retrieve Menu Item Ingredients",
    "Get_Scoring_Categories_Error": "Failed To Retrieve Scoring Categories"
  },
  "Spatial": {
    "Get_Hub_Geofence_Error": "Failed To Retrieve Hub Geofence",
    "Check_Service_Area_Error": "Failed to check service area availability"
  },
  "Admin": {
    "Admin": "Admin",
    "Admin_Mode_Enabled": "Admin Mode Enabled",
    "General": "General",
    "Go_To_Home": "Go To Home",
    "Go_To_Settings": "Go To Settings",
    "Clear_Availability_Address": "Clear Availability Address",
    "Go_To_Availability": "Go To Availability",
    "Available_In_Area": "Available In Area",
    "Onboarding": "Onboarding",
    "Onboarding_Completed": "Onboarding Completed",
    "Onboarding_Learning_Completed": "Onboarding Learning Completed",
    "Clear_User_Enable_Onboarding": "Clear User & Enable Onboarding",
    "Reset_User_Disable_Onboarding": "Set User & Disable Onboarding",
    "Health": "Health",
    "Starting_Line_Complete": "Starting Line Complete",
    "N_Of_1_Enabled": "NOf1 Enabled",
    "Biometrics_Available_Web_Only": "Biometrics Available (Web Only)",
    "Ordering": "Ordering",
    "Clear_Cart": "Clear Cart",
    "Lock_Nutrient_Program": "Lock Nutrient Program (Read-Only)",
    "Trigger_Sold_Out": "Trigger Sold Out (First S&S Lunch)",
    "Disable_HTTP_Cache": "Disable HTTP Cache",
    "Clear_HTTP_Cache": "Clear HTTP Cache",
    "Show_Test_Notification": "Show Test Notification",
    "App_State": "App State",
    "View_App_State": "View App State",
    "Copy_To_Clipboard": "Copy To Clipboard",
    "History": "History",
    "View_History": "View History",
    "Skip_Onboarding": "Skip Onboarding",
    "Start_Onboarding": "Start Onboarding",
    "Jump_To_Step": "Jump To Step",
    "Current_Step": "Current step",
    "Clear_Onboarding_State": "Clear Onboarding State",
    "Onboarding_Controls": "Onboarding Controls",
    "Step_Learning": "Learning",
    "Step_Availability": "Availability",
    "Step_AvailabilityResult": "Availability Result",
    "Step_AboutYou": "About You",
    "Step_RightPlace": "Right Place",
    "Step_PlanSelection": "Plan Selection",
    "Step_AddMembers": "Add Members",
    "Step_Agreements": "Agreements",
    "Step_Payment": "Payment"
  },
  "Biometric": {
    "Checking_Biometrics_Failed": "Checking Biometrics Failed",
    "Enabling_Biometrics_Failed": "Enabling Biometrics Failed",
    "Biometric_Login_Failed": "Biometric Login Failed",
    "Sign_In_Securely": "Sign In Securely",
    "Biometrics_Not_Enabled": "Biometrics Not Enabled"
  },
  "Daily_Nutrient_Plan": {
    "Title": "Daily Personal Prescriptive Nutrient Plan",
    "Subtitle": "Your Prescriptive Nutrient Plan is not quite ready yet, but you can view a sample below.",
    "Daily_Targets": "Daily Targets",
    "Detailed_Nutrient_Goals": "Detailed Nutrient Goals",
    "Calories": "Calories",
    "Hydration": "Hydration",
    "cal": "cal",
    "HydrationHeader_Note": "Note: Water from food. Increase 12 oz for every 30 mins of physical activity.",
    "PhytonutrientsHeader_Description": "Specific targets for phytonutrient intake are still a developing science. Follow this guide to ensure adequate intake of these critical nutrients:</br></br><strong>Eat a rainbow of fruits and vegetables daily.</strong> Aim for at least 5 servings of fruits and vegetables per day, with a focus on variety to cover a broad spectrum of phytonutrients. For example: <ul><li><strong>Orange/Yellow</strong> fruits and vegetables for alpha and beta-carotene (e.g., carrots, sweet potatoes, pumpkins, apricots).</li><li><strong>Red</strong> fruits and vegetables for lycopene and anthocyanidins (e.g., tomatoes, watermelon, red cabbage, berries).</li><li><strong>Green</strong> vegetables for lutein and zeaxanthin (e.g., kale, spinach, broccoli).</li></ul><strong>Include nuts, seeds, and whole grains.</strong> These are good sources of various flavonoids and other phytonutrients. For example: <ul><li>Flaxseeds and chia seeds for lignans (a type of polyphenol).</li><li>Whole grains like oats and barley for various phenolic acids.</li></ul>",
    "Essential_Indicator": "indicates essential nutrient",
    "Viewing_Sample": "Viewing sample Prescriptive Nutrient Plan.",
    "Viewing_Sample_Title": "You're viewing a sample plan.",
    "Sample_Data": "Sample data",
    "Title_With_Name": "Daily Personal Prescriptive Nutrient Plan prepared for {{name}}",
    "Subtitle_Real": "This plan is tailored to your biometrics and current health profile. Review your daily targets below."
  },
  "Nutrient_Info": {
    "NetCarbohydratesHeader": "Net Carbohydrates",
    "FiberHeader": "Fiber",
    "SugarHeader": "Sugar",
    "FatsHeader": "Total Fat",
    "TotalProteinHeader": "Total Protein",
    "VitaminsHeader": "Vitamins",
    "MineralsHeader": "Minerals",
    "HydrationHeader": "Hydration",
    "PhytonutrientsHeader": "Phytonutrients",
    "CriticalDailyEssentialHeader": "Critical Daily Essential Nutrients",
    "RequiredDailyEssentialHeader": "Required Daily Essential Nutrients",
    "RequiredDailyEnergyBalanceHeader": "Required Daily Energy Balance Nutrients",
    "NutrientsToMinimizeHeader": "Nutrients to Minimize",
    "WaterHeader": "Water",
    "netCarbohydrates": "Net Carbohydrates",
    "totalFat": "Total Fat",
    "totalProtein": "Total Protein",
    "totalFiber": "Total Fiber",
    "solubleFiber": "Total Soluble Fiber",
    "insolubleFiber": "Total Insoluble Fiber",
    "totalSugar": "Total Sugar",
    "addedSugars": "Total Added Sugar",
    "totalSaturatedFat": "Total Saturated Fat",
    "totalMonounsaturatedFat": "Total Monounsaturated Fat",
    "totalPolyunsaturatedFat": "Total Polyunsaturated Fat",
    "totalTransFat": "Total Trans Fat",
    "linoleicAcidOmega6": "Linoleic Acid (LA) (Omega 6) PUFA",
    "alphaLinoleicAcidOmega3": "Linolenic Acid (ALA) (Omega 3) PUFA",
    "epaDha": "EPA + DHA",
    "histidine": "Histidine",
    "isoleucine": "Isoleucine",
    "leucine": "Leucine",
    "lysine": "Lysine",
    "methionine": "Methionine",
    "phenylalanine": "Phenylalanine",
    "threonine": "Threonine",
    "tryptophan": "Tryptophan",
    "valine": "Valine",
    "vitaminA": "Vitamin A (Retinol)",
    "vitaminB1": "Vitamin B1 (Thiamin)",
    "vitaminB2": "Vitamin B2 (Riboflavin)",
    "vitaminB3": "Vitamin B3 (Niacin)",
    "vitaminB5": "Vitamin B5 (Pantothenic Acid)",
    "vitaminB6": "Vitamin B6 (Pyridoxine)",
    "vitaminB7": "Vitamin B7 (Biotin)",
    "vitaminB9": "Vitamin B9 (Folate)",
    "vitaminB12": "Vitamin B12 (Cyanocbalamin)",
    "vitaminC": "Vitamin C (Ascorbic Acid)",
    "vitaminD3": "Vitamin D3",
    "vitaminE": "Vitamin E (D-Alpha-Tocopherol)",
    "vitaminK": "Vitamin K",
    "chloride": "Chloride",
    "choline": "Choline",
    "calcium": "Calcium",
    "chromium": "Chromium",
    "copper": "Copper",
    "flouride": "Fluoride",
    "iodine": "Iodine",
    "iron": "Iron",
    "magnesium": "Magnesium",
    "manganese": "Manganese",
    "molybedenum": "Molybdenum",
    "phosporus": "Phosphorus",
    "potassium": "Potassium",
    "selenium": "Selenium",
    "sodium": "Sodium",
    "water": "Water",
    "zinc": "Zinc"
  },
  "Nutrient_Automation": {
    "Title": "Nutrient Profile",
    "My_Nutrient_Profile": "My Nutrient Profile",
    "My_Nutrient_Profile_Description": "Answer the following question to customize your nutrient program to save you time, money and stress. We are here to make your life easier and help you get the nutrients you need!",
    "Percent_Completed": "{{percent}}% COMPLETED",
    "Completed": "Completed",
    "Last_Updated": "Last Updated {{date}}",
    "Ingredient_Standards": {
      "Title": "Ingredient Standards",
      "Description": "Please select additional quality standards you'd like us to follow"
    },
    "Allergens_Intolerances": {
      "Title": "Allergens & Intolerances",
      "Intro": "Please share information about your allergies and intolerances."
    },
    "Food_Preferences": {
      "Title": "Food Preferences",
      "Intro": "Please share your preferences to help us recommend items you will love!"
    }
  },
  "Household_Automation": {
    "Title": "Household Nutrient Automation Settings",
    "Subtitle": "Customize your nutrient program for your household.",
    "Section_Title": "Household Nutrient Settings",
    "Intents_Title": "Make My Life Easy",
    "Intents_Description": "Please select your program & schedule works for you.",
    "Delivery_Title": "Delivery Preferences",
    "Delivery_Description": "Please set your delivery preferences.",
    "Payment_Title": "Payment & Cost",
    "Payment_Description": "Please share your spending goals so we can tailor your program to fit your budget.",
    "Tour_Intents_Title": "Automate Your Optimal Weekly Nourishment",
    "Tour_Intents_Body": "Choose \"At Home\" to receive a menu item or use \"Dine Out\" / \"No Meal\" to plan your week.",
    "Tour_Delivery_Title": "Delivery for Schedule Ahead & Save",
    "Tour_Delivery_Body": "Our menu items maintain 5 days of freshness when properly refrigerated. For optimal freshness we want to deliver your menu items 1-2 days before your planned consumption.",
    "Tour_Delivery_Body_2": "All menu items are kept fully refrigerated. When selecting availability be prepared to move your items to your fridge to maintain freshness.",
    "Tour_Delivery_Body_3": "If you anticipate that you won't be immediately available add returnable ice packs to your order.",
    "Tour_Delivery_Agreement": "I have read and agree to the freshness agreement.",
    "Tour_Payment_Title": "Optimal for your Health",
    "Tour_Payment_Body": "We have recommended your items based off your nutrient needs, preferences and how you've previously rated your menu items, restaurant and chef.",
    "Intents_Subtitle": "This automation eating is great for soccer practice nights or recurring brunch plans. You can always change this later.",
    "Intents_Question": "Any meals that you'll regularly exclude from your program?",
    "Delivery_Subtitle": "Ice is available at check out if you want to be immediately available.",
    "Delivery_Question": "When should we typically deliver your items?",
    "Payment_Question": "How much money are you willing to spend per meal (per person)? Select all that apply.",
    "Payment_Dependent_Note": "A dependent's budget starts at the lowest range. The household's owner, an admin or the dependent's guardian can change it.",
    "Not_Available": "Not Available",
    "Get_Intent_Schedule_Error": "Unable to load intent schedule. Please try again.",
    "Update_Intent_Schedule_Error": "Unable to update intent schedule. Please try again.",
    "Get_Household_Intent_Error": "Unable to load household intent schedule. Please try again.",
    "Update_Household_Intent_Error": "Unable to update household intent. Please try again.",
    "Get_Delivery_Error": "Unable to load delivery availability. Please try again.",
    "Update_Delivery_Error": "Unable to update delivery availability. Please try again.",
    "Get_Cost_Error": "Unable to load cost preferences. Please try again.",
    "Save_Cost_Error": "Unable to save cost preferences. Please try again.",
    "Get_Budget_Error": "Unable to load household budget. Please try again.",
    "Update_Budget_Error": "Unable to update household budget. Please try again."
  },
  "Allergens": {
    "Peanuts": "Peanuts",
    "Animal_Milk": "Animal Milk",
    "Eggs": "Eggs",
    "Fish": "Fish",
    "Shellfish": "Shellfish",
    "Tree_Nuts": "Tree Nuts",
    "Wheat": "Wheat",
    "Soybeans": "Soybeans",
    "Sesame": "Sesame",
    "Gluten": "Gluten",
    "Mustard": "Mustard",
    "Celery": "Celery",
    "None": "None"
  },
  "Intolerances": {
    "Lactose": "Lactose",
    "Gluten": "Gluten",
    "Fructose": "Fructose",
    "FODMAP": "FODMAP",
    "Histamine": "Histamine",
    "Caffeine": "Caffeine",
    "Sulfites": "Sulfites",
    "MSG": "MSG",
    "Raw_Tomatoes": "Raw Tomatoes",
    "Salicylates": "Salicylates",
    "None": "None"
  },
  "Allergens_Intolerances_Page": {
    "Title": "Allergies & Intolerances",
    "Allergens_Title": "Allergens",
    "Allergens_Description": "Select any of the allergens below that when consumed would cause severe discomfort or physical harm:",
    "Allergens_Info": "Your menu will not include items with significant amounts of these ingredients.",
    "View_Allergen_Details": "Please view additional allergen details.",
    "Allergens_Required_Note": "*At least one box must be selected. If none of the below are allergens, select \"none\".",
    "Choose_Allergens": "Choose Allergens",
    "Details": "Details",
    "Intolerances_Title": "INTOLERANCES",
    "Intolerances_Description": "Select any of the items below that when consumed cause some discomfort or impairment:",
    "Intolerances_Required_Note": "*At least one box must be selected. If none of the below are intolerances, select \"none\".",
    "Choose_Intolerances": "Choose Intolerances",
    "Privacy_Question": "Is my data kept private?"
  },
  "Allergen_Details": {
    "Milk": {
      "Title": "Milk Allergen Details",
      "Description": "Milk is a common food allergen that comes from the milk of mammals such as cows, goats, and sheep. Milk proteins are widely used in many food products and ingredients.",
      "Products_Header": "Foods Containing Milk Include:",
      "Products": "Butter, Buttermilk, Casein, Caseinate (Sodium Caseinate, Calcium Caseinate), Cheese, Condensed Milk, Cottage Cheese, Cream, Cream Cheese, Custard, Evaporated Milk, Ghee, Half-and-Half, Ice Cream, Lactalbumin, Lactoglobulin, Milk Powder, Milk Protein, Milk Solids, Ricotta, Sour Cream, Whey, Whey Protein, Whipped Cream, Yogurt",
      "Note": "Milk does not include plant-based milk alternatives such as almond milk, soy milk, oat milk, coconut milk, or rice milk."
    },
    "Gluten": {
      "Title": "Gluten Allergen Details",
      "Description": "Gluten is a group of proteins found in certain grains. It helps foods maintain their shape by acting as a binding agent. Gluten is naturally present in several cereal grains and foods made from them.",
      "Products_Header": "Foods Containing Gluten Include:",
      "Products": "Barley, Barley Malt, Bran, Bread, Bulgur, Couscous, Crackers, Durum, Einkorn, Emmer, Farina, Farro, Graham Flour, Kamut, Malt, Malt Extract, Malt Flavoring, Malt Vinegar, Pasta, Rye, Seitan, Semolina, Spelt, Triticale, Wheat, Wheat Germ, Wheat Bran, Wheat Starch, Wheat Flour",
      "Note": "Gluten does not include naturally gluten-free grains or foods such as rice, corn, quinoa, millet, buckwheat, sorghum, potatoes, or products specifically labeled gluten-free."
    },
    "Wheat": {
      "Title": "Wheat Allergen Details",
      "Description": "Wheat is a cereal grain commonly used to make flour and many food products. It is one of the most common food allergens and is present in a wide variety of baked goods and processed foods.",
      "Products_Header": "Foods Containing Wheat Include:",
      "Products": "Bread, Bagels, Biscuits, Breading, Bulgur, Cakes, Cereal, Couscous, Crackers, Croissants, Dumplings, Farina, Flour (Wheat Flour, All-Purpose Flour, Bread Flour), Gravies Thickened with Wheat Flour, Noodles, Pancakes, Pasta, Pastries, Pizza Dough, Pretzels, Semolina, Seitan, Wheat Bran, Wheat Germ, Wheat Starch, Wheat Protein",
      "Note": "Wheat does not include grains that do not contain wheat, such as rice, corn, oats (if certified wheat-free), quinoa, millet, buckwheat, sorghum, or products specifically labeled wheat-free."
    }
  },
  "Intolerance_Details": {
    "Milk": {
      "Title": "Milk Intolerance Details",
      "Description": "Milk intolerance occurs when the body has difficulty digesting certain components of milk, most commonly lactose, the natural sugar found in milk. This can cause digestive discomfort in some individuals.",
      "Products_Header": "Foods That May Contain Milk or Lactose Include:",
      "Products": "Butter, Buttermilk, Cheese, Cream, Cream Cheese, Custard, Evaporated Milk, Ice Cream, Milk, Milk Powder, Milk Solids, Ricotta, Sour Cream, Whey, Whey Protein, Yogurt",
      "Note": "Milk intolerance does not apply to plant-based milk alternatives such as almond milk, soy milk, oat milk, coconut milk, or rice milk. Some people with milk intolerance may tolerate small amounts or lactose-free dairy products, depending on individual sensitivity."
    },
    "Gluten": {
      "Title": "Gluten Intolerance Details",
      "Description": "Gluten intolerance occurs when the body has difficulty digesting gluten, a group of proteins found in certain grains. This can lead to digestive discomfort or sensitivity in some individuals.",
      "Products_Header": "Foods That May Contain Gluten Include:",
      "Products": "Barley, Bread, Bulgur, Couscous, Crackers, Farina, Farro, Malt, Pasta, Rye, Seitan, Semolina, Spelt, Triticale, Wheat, Wheat Flour",
      "Note": "Gluten intolerance does not include naturally gluten-free grains such as rice, corn, quinoa, millet, buckwheat, or sorghum. Some individuals with gluten intolerance may tolerate very small amounts of gluten, depending on their level of sensitivity."
    },
    "Wheat": {
      "Title": "Wheat Intolerance Details",
      "Description": "Wheat intolerance occurs when the body has difficulty digesting wheat or certain components found in wheat-based foods. This may cause digestive symptoms in some individuals.",
      "Products_Header": "Foods That May Contain Wheat Include:",
      "Products": "Bread, Bagels, Biscuits, Breading, Bulgur, Cakes, Cereal, Crackers, Couscous, Dumplings, Flour (Wheat Flour, All-Purpose Flour), Noodles, Pancakes, Pasta, Pastries, Pizza Dough, Pretzels, Semolina, Wheat Bran, Wheat Germ, Wheat Starch",
      "Note": "Wheat intolerance does not include grains that do not contain wheat, such as rice, corn, quinoa, millet, buckwheat, or sorghum. Some individuals with wheat intolerance may tolerate small amounts or specially processed wheat products, depending on sensitivity."
    }
  },
  "Food_Preferences_Page": {
    "Title": "Food Preferences",
    "Common_Dislikes_Title": "Common Dislikes",
    "Common_Dislikes_Description": "Help us to further simplify your life by sharing your food preferences. We will automatically apply these so you never have to again",
    "Spice_Level_Title": "Spice level",
    "Spice_Level_Description": "We'll only show you items at the level you select or less on the spice scale. Remember, you can always add more spice on your own but you cannot take it away.",
    "Spice_Level_1": "Little to none",
    "Spice_Level_2": "Mild",
    "Spice_Level_3": "Some",
    "Spice_Level_4": "Medium",
    "Spice_Level_5": "Lots",
    "Cuisine_Preferences_Title": "Cuisine preferences",
    "Cuisine_Preferences_Description": "Select your cuisine preferences",
    "Dislike": "Dislike",
    "No_Preference": "No Preference",
    "Love": "Love"
  },
  "Ingredient_Standards_Page": {
    "Title": "Ingredient Standards",
    "Subtitle": "Select your preferences for the upgrade options below, marked with approximate cost impact.",
    "Select_Your_Preferences": "Select your preferences for the upgrade options below, marked with approximate cost impact.",
    "Not_Required": "Not Required",
    "Preferred": "Preferred",
    "Required": "Required",
    "Section_1_Title": "Fruits and Vegetables Standards",
    "Section_1_Description": "Youtopia Standard: Washed Conventional and Block Dirty Dozen",
    "Section_1_Question_1_Title": "Always Organic Produce when available ($$$$)",
    "Section_2_Title": "Egg Standards",
    "Section_2_Description": "Youtopia Standard: Cage Free, Non-GMO, antibiotic and hormone free",
    "Section_2_Question_1_Title": "USDA Organic and/or Pasture Raised ($$$)",
    "Section_3_Title": "Poultry Standards (Chicken, Turkey)",
    "Section_3_Description": "Youtopia Standard: Cage Free, Antibiotic and Growth Hormone Free",
    "Section_3_Question_1_Title": "USDA Organic free range, antibiotic and growth hormone free ($$$)",
    "Section_4_Title": "Pork Standards",
    "Section_4_Description": "Youtopia Standard: Antibiotic and growth hormone free, natural feed with up to 50% grain",
    "Section_4_Question_1_Title": "Raised on pasture, finished with grain free foraging blend ($)",
    "Section_5_Title": "Red Meat Standards (Beef, Bison, Sheep)",
    "Section_5_Description": "Youtopia Standard: Pasture Raised, except for finishing",
    "Section_5_Question_1_Title": "Pasture Raised, Pasture Finished ($$$)",
    "Section_5_Question_2_Title": "Organic Grass Fed Grass Finished ($$$$$)",
    "Section_6_Title": "Seafood Standards",
    "Section_6_Description": "Youtopia Standard: Responsibly and sustainably farmed: no use of antibiotics, artificial coloring or GMO feed",
    "Section_6_Question_1_Title": "Wild and sustainably caught (Marine Stewardship Council certified, or rated green or yellow by Monterey Bay Aquarium Seafood Watch) ($$$)",
    "Section_7_Title": "Dairy Standards",
    "Section_7_Description": "Youtopia Standard: Pasteurized, rBST free for milk, yogurt, butter, ghee, cheese, ice cream",
    "Section_7_Question_1_Title": "Organic and/or Grass Fed ($$$)",
    "Section_8_Title": "Alternative Dairy Standards",
    "Section_8_Description": "Youtopia Standard: Non-GMO for unsweetened nut milk, seed milk, and oat milk",
    "Section_8_Question_1_Title": "USDA Organic, Non-GMO ($$$)",
    "Section_9_Title": "Production Facility Certification Standards",
    "Section_9_Question_1_Title": "Kosher Certified",
    "Section_9_Question_2_Title": "Gluten-free Certified",
    "Section_9_Question_3_Title": "Nut-free Certified",
    "Section_9_Question_4_Title": "Halal Certified"
  },
  "Ingredient_Standards": {
    "FruitsAndVegetables": "Fruits And Vegetables",
    "Egg": "Eggs",
    "Poultry": "Poultry",
    "Pork": "Pork",
    "RedMeatPasture": "Red Meat Pasture",
    "RedMeatOrganic": "Red Meat Organic",
    "Seafood": "Seafood",
    "Dairy": "Dairy",
    "AlternativeDairy": "Alternative Dairy",
    "Kosher_Info_Title": "Kosher Certification",
    "Kosher_Info_Body": "Kosher certification ensures food is prepared according to Jewish dietary laws.",
    "Gluten_Free_Info_Title": "Gluten-Free Certification",
    "Gluten_Free_Info_Body": "Gluten-free certification indicates the product meets standards for gluten-free labeling.",
    "Nut_Free_Info_Title": "Nut-Free Certification",
    "Nut_Free_Info_Body": "Nut-free certification ensures the product is free from tree nuts and peanuts.",
    "Halal_Info_Title": "Halal Certification",
    "Halal_Info_Body": "Halal certification ensures food is prepared according to Islamic dietary laws."
  },
  "Certifications": {
    "Kosher": "Kosher",
    "GlutenFree": "Gluten Free",
    "NutFree": "Nut Free",
    "Halal": "Halal"
  },
  "My_Profile": {
    "Title": "My Profile",
    "First_Name": "First Name",
    "Last_Name": "Last Name",
    "Email": "Email",
    "Phone": "Phone",
    "Get_Profile_Error": "Failed to load profile",
    "Update_Profile_Error": "Failed to update profile",
    "Profile_Updated": "Profile updated successfully",
    "Update_Image_Error": "Failed to update profile image",
    "Image_Updated": "Profile image updated",
    "Invalid_Email": "Please enter a valid email address",
    "Change_Profile_Image": "Change profile image",
    "Information": "Information",
    "Personal_Information": "Personal Information",
    "Guardian_Information": "Guardian Information",
    "Legal_First_Name": "Legal First Name",
    "Legal_Last_Name": "Legal Last Name",
    "Date_Of_Birth": "Date of Birth",
    "Guardians_Listed_Below": "Guardians are listed below.",
    "Guardians_Listed_Below_Named": "{{name}}'s guardians are listed below.",
    "Personal_Info_Support": "Contact us at support@youtopia.com for corrections to your date of birth or to change your email address.",
    "Guardian_Info_Support": "Contact us at support@youtopia.com for corrections to this information.",
    "Plan_Coverage": "Plan coverage",
    "Plan_Coverage_Description": "I'm covering my plan",
    "Plan_Coverage_Description_Other": "I'm covering their plan",
    "Plan_Coverage_Description_Covered": "Someone else is covering my plan",
    "Plan_Coverage_Description_Covered_Named": "{{name}} is covering my plan",
    "Monthly_Cost": "Monthly cost",
    "No_Plan": "No plan assigned",
    "Guardian": "Guardian",
    "Guardian_Not_Guardian": "I am not this persons guardian",
    "Guardian_Is_Guardian": "I am this persons guardian",
    "Guardian_List": "Guardians: {{names}}",
    "Permissions": "Permissions",
    "Permissions_Can": "Can",
    "Permissions_None_Offered": "This invitation didn’t come with any permissions to grant.",
    "Permissions_On_Acceptance": "When this invitation is accepted:",
    "Permissions_Cannot": "Cannot",
    "Permissions_Order_Household": "Order for household",
    "Permissions_Manage_Order_Guests": "Manage order guests",
    "Permissions_Buy_Memberships": "Buy memberships",
    "Permissions_View_Health": "View your health and nutrition info",
    "Permissions_Others_View_Health": "Others can view my health and nutrition info",
    "Permissions_View_Their_Health": "View their health and nutrition info",
    "Permissions_Others_View_Their_Health": "View their health and nutrition info",
    "Health_Sharing": "Health data",
    "Health_Sharing_Default": "Your health data is shared with your guardians by default",
    "Health_Sharing_Toggle": "Share my health data with {{name}}",
    "Health_Sharing_Shares_With_You": "{{name}} shares their health data with you",
    "Health_Sharing_Not_Shared_With_You": "{{name}} does not share their health data with you",
    "Remove": "Remove",
    "Add_Profile_Photo": "Add profile photo",
    "Upload_File": "Upload file",
    "Image_Size_Limit": "Image cannot exceed 5MB",
    "Upload_Image_Error": "Failed to upload profile image",
    "Set_As_Admin": "Set as Admin",
    "Remove_Admin": "Remove admin",
    "Admin_Footer": "Admins can edit and order for the whole household. You can revoke anytime.",
    "Revoke_Admin_Footer": "{{name}} is an admin. Removing removes admin permissions.",
    "Make_Admin_Title": "Make {{name}} an admin?",
    "Make_Admin_Body_Access": "Give {{name}} the same access you have?",
    "Make_Admin_Body_Capabilities": "Admins can edit the whole household and order for the whole household.",
    "Make_Admin_Body_Revoke": "You can revoke this anytime.",
    "Revoke_Admin_Title": "Remove {{name}} as admin?",
    "Revoke_Admin_Body_Regular": "{{name}} will return to a regular member and can only act for themselves.",
    "Revoke_Admin_Body_Reversible": "You can make them an admin again anytime.",
    "Admin_Granted": "{{name}} is now an admin",
    "Admin_Revoked": "{{name}} is no longer an admin",
    "Remove_Member_Title": "Remove {{name}}?",
    "Remove_Member_Body": "{{name}} will be removed from your household and will no longer have access.",
    "Member_Removed": "{{name}} has been removed"
  },
  "Invitation_Profile": {
    "Invite_Sent": "Invite sent {{date}} - awaiting response.",
    "Invite_Invalid": "This invitation is no longer valid.",
    "Invite_Expired": "This invitation has expired. Resend it to invite them again.",
    "Invite_Staged": "Awaiting purchase. This invitation will be sent once a plan seat is purchased.",
    "Remove_Staged_Invite": "Remove Invite",
    "Remove_Staged_Invite_Confirm_Message": "This removes the staged invitation for {{name}}. Nothing has been sent to them.",
    "Resend_Invite": "Resend Invite",
    "Resend_Invite_Success": "Invitation resent successfully",
    "Remove_Member": "Remove Member",
    "Remove_Member_Confirm_Message": "This invitation will become invalid for {{name}} and we will cancel their plan.",
    "Remove_Member_Cancel": "Cancel",
    "Remove_Member_Confirm": "Remove"
  },
  "Payment_Information": {
    "Title": "Payment Information",
    "Payment_Methods": "Payment Methods",
    "No_Payment_Methods": "No payment methods yet",
    "Add_Payment_Method": "Add Payment Method",
    "Default_Payment": "Default Payment",
    "Gift_Cards": "Gift Cards",
    "Redeem_Gift_Card": "Redeem Gift Card",
    "Send_Gift_Card": "Send a Gift Card",
    "Set_To_Default": "Set to default",
    "Delete_Payment": "Delete payment",
    "Delete_Payment_Title": "Delete Payment?",
    "Delete_Payment_Message": "Are you sure you want to delete this payment method? This cannot be undone.",
    "Set_Default_Title": "Set as default?",
    "Set_Default_Message": "•••• {{last4}} will be used for future membership payments, used as the default payment when checking out, and will be available to household members with permission to your household wallet.",
    "Payment_Deleted": "Payment method deleted",
    "Default_Payment_Updated": "Default payment updated",
    "Delete_Failed": "Failed to delete payment method",
    "Set_Default_Failed": "Failed to update default payment"
  },
  "Payment_Method": {
    "Title": "Payment Method",
    "Add_Payment": "Add Payment",
    "Edit_Payment": "Edit Payment",
    "Default_Payment": "Default Payment",
    "Edit_Payment_Method": "Edit Payment Method",
    "Default_Payment_Description": "This method will be used for future purchases. To change it, set another method as default.",
    "Make_Default": "Make Default",
    "Delete_Payment_Method": "Delete Payment Method",
    "Delete_Payment_Method_Description": "Are you sure you want to delete this payment method? This cannot be undone."
  },
  "Address_Book": {
    "Title": "Address Book",
    "Add_Address": "Add Address",
    "Edit_Address": "Edit Address",
    "Address_Number": "Address {{num}}",
    "Add_New_Address": "Add New Address",
    "Default": "Default",
    "Default_Address": "Default Address",
    "Default_Address_Description": "This address will be used for delivery by default. To change it, set another address as default.",
    "Make_Default": "Make Default",
    "Out_Of_Range_Title": "Out of range for default",
    "Out_Of_Range_Message": "The address you entered is too far away, we can't deliver schedule ahead and save orders there. Contact us for additional info at",
    "No_Addresses": "You don't have any addresses",
    "No_Addresses_Description": "Add an address to make ordering faster and easier.",
    "Address_Title": "Address Title",
    "Delivery_Instructions": "Delivery Instructions",
    "Address": "Address",
    "Address_2": "Address 2",
    "City": "City",
    "State": "State",
    "Zip_Code": "ZIP Code",
    "Country": "Country",
    "Delete_Address_Title": "Delete Address?",
    "Delete_Address_Message": "Are you sure you want to delete this address? This cannot be undone.",
    "Get_Addresses_Error": "Failed to load addresses",
    "Get_Address_Error": "Failed to load address",
    "Create_Address_Error": "Failed to create address",
    "Update_Address_Error": "Failed to update address",
    "Delete_Address_Error": "Failed to delete address",
    "Set_Default_Address_Error": "Failed to set default address",
    "Set_To_Default": "Set to default",
    "Delete_Address": "Delete address",
    "Set_Default_Title": "Set as default?",
    "Set_Default_Message": "{{name}} will be the address used for all future schedule ahead and save orders.",
    "Address_Deleted": "Address deleted",
    "Default_Address_Updated": "Default address updated"
  },
  "Address_Validation": {
    "Title": "Verify Your Address",
    "Description": "We found a suggested address that may be more accurate.",
    "Unable_To_Validate": "We were unable to validate your address. Please check for errors.",
    "You_Entered": "You Entered",
    "Suggested_Address": "Suggested Address",
    "Use_Suggested": "Use Suggested Address",
    "Edit_What_I_Entered": "Edit What I Entered"
  },
  "Order_History": {
    "Orders": "Orders",
    "No_Orders": "You haven't placed any orders yet",
    "One_Item": "(1 item)",
    "Multiple_Items": "({{count}} items)",
    "Current_Orders": "Current Orders",
    "Completed_Orders": "Completed Orders",
    "History": "Order History",
    "Upcoming_Orders": "Upcoming Orders",
    "Upcoming_Empty": "You don't have any orders coming up",
    "Delivery": "Delivery",
    "Pick_Up": "Pick Up",
    "Dine_Out": "Dine Out",
    "Membership": "Membership",
    "Delivery_Number_Of": "Delivery {{number}} of {{count}}",
    "Shared_Delivery": "Shared delivery ({{count}} orders)",
    "Couldnt_Be_Completed": "Couldn't be completed",
    "Items_Being_Refunded": "{{count}} items being refunded",
    "Arriving_Between_Time": "Arriving between {{start}} - {{end}}",
    "Get_Orders_Error": "Failed to load orders",
    "Order_Status_Title_Delivered": "Your order has been delivered",
    "Order_Status_Title_Placed": "Your order has been placed",
    "Order_Status_Title_Preparing": "Your order is being prepared",
    "Order_Status_Title_BeingPickedUp": "Your order is being picked up",
    "Order_Status_Title_OnTheWay": "Your order is on the way",
    "Order_Status_Title_ReadyForPickup": "Your order is ready for pickup",
    "Order_Status_Title_Declined": "Your order has been declined",
    "Order_Status_Message_Delivered": "Your order has been delivered. Enjoy your meal!",
    "Order_Status_Message_Placed": "Your order is being confirmed with {{establishmentName}}.",
    "Order_Status_Message_Placed_Generic": "Your order is being confirmed.",
    "Order_Status_Message_Placed_Membership": "Your membership is being confirmed.",
    "Order_Status_Message_Preparing": "Your order is being prepared at {{establishmentName}}.",
    "Order_Status_Message_Preparing_Generic": "Your order is being prepared.",
    "Order_Status_Message_Preparing_Membership": "Your membership is being processed.",
    "Order_Status_Message_BeingPickedUp": "Your delivery driver is heading to the restaurant.",
    "Order_Status_Message_OnTheWay": "Your delivery driver has your order and is heading to you.",
    "Order_Status_Message_ReadyForPickup": "Your order is ready for pickup",
    "Order_Status_Message_Declined": "Your order has been declined by {{establishmentName}}.",
    "Order_Status_Message_Declined_Generic": "Your order has been declined.",
    "Order_Status_Message_Declined_Membership": "Your membership order has been declined.",
    "Status": {
      "Delivered": "Delivered",
      "AwaitingCourier": "Awaiting Driver",
      "CollectedByCourier": "Picked Up By Driver",
      "InTransit": "In Transit",
      "Pending": "Pending",
      "Paid": "Paid",
      "Completed": "Completed",
      "Partially_Refunded": "Partially Refunded",
      "Refunded": "Refunded",
      "Rejected": "Rejected",
      "Declined": "Declined",
      "Returning": "Returning",
      "Returned": "Returned",
      "Unknown": "Unknown"
    },
    "Show_More": "Show more"
  },
  "Availability": {
    "Title": "Welcome to Youtopia",
    "Check_Availability": "Check availability",
    "Check_Availability_Description": "Youtopia is continuously expanding, see if we’re available in your area.",
    "Check_My_Area": "Check My Area"
  },
  "Availability_Result": {
    "Title": "Welcome to Youtopia",
    "Good_News_Title": "Good news automated precision nourishment is in your area.",
    "Not_In_City_Yet": "We’re not in your city yet",
    "Not_In_City_Yet_Description": "Vote and share with others that you want Youtopia in your area soon. We'll keep you in the know as we grow.",
    "Keep_Me_Informed": "Keep Me Informed",
    "No_Thanks": "No Thanks",
    "Try_Different_Address": "Try a different address",
    "Info_Card_1": "Now your evolving biological needs can be met through a variety of local delicious Youtopia certified menu items.",
    "Info_Card_2": "Are you ready to feel your best as you journey within your very own perpetual wellness system?",
    "Info_Card_3": "Becoming a Youtopian is joining a community of people who value wellness and delicious food that truly is medicine for their body and protecting the environment.",
    "Lets_Go": "Let's Go"
  },
  "Outside_Area": {
    "Title": "Youtopia",
    "Upvote_City": "Upvote {{city}}",
    "Upvote_City_Description": "Invite your friends to up vote your city. The most voted city will provide us insights on where to open next!",
    "Invite_Friends": "Invite Friends",
    "Get_Notified": "Get Notified",
    "Not_In_Your_City_Yet": "We’re not in your city yet",
    "Not_In_Your_City_Yet_Description": "Youtopia isn’t available in your city yet but we’ve added your vote and will let you know when we are!",
    "On_List": "On List",
    "On_List_Description": "We’ll email you when Youtopia is available in your area."
  },
  "About_You": {
    "Title": "Welcome to Youtopia",
    "Save_Error": "We couldn't save your information. Please try again.",
    "Its_Great_To_Meet_You": "It's great to meet you!",
    "Its_Great_To_Meet_You_Description": "Our Youtopian community strives for vibrant health and longevity, and we’re excited you want to join us!",
    "What_Should_We_Call_You": "What should we call you?",
    "More_About_You": "Let us know more about you",
    "More_About_You_Description": "Create an account so we can remember your goals and keep everything in sync.",
    "Legal_First_Name": "Legal First Name",
    "Legal_Last_Name": "Legal Last Name",
    "Date_Of_Birth": "Date Of Birth",
    "Signup_Minimum_Age_Error": "You must be at least {{age}} years old to join Youtopia.",
    "Email": "Email",
    "Phone": "Phone",
    "Friend": "Friend",
    "Social_Media_Post": "Social Media Post",
    "TV_Commercial": "TV Commercial",
    "Functional_Medicine_Doctor": "Functional Medicine Doctor",
    "Nutritionist": "Nutritionist",
    "Dietician": "Dietician",
    "Gym_Promotion": "Gym Promotion",
    "Source": "Source"
  },
  "Right_Place": {
    "Title": "Welcome to Youtopia",
    "Placeholder_Notice": "These options are placeholders and haven’t been finalized yet.",
    "Selection_Greeting": "Welcome, {{name}}!",
    "Selection_Greeting_No_Name": "Welcome!",
    "Selection_Prompt": "What are you hoping Youtopia can help you with?",
    "We_Do_All_Of_That": "We do all of that and more.",
    "Congrats_Your_In_The_Right_Place": "Congratulations, you’re in the <span class=\"text-highlight\">right place.</span>",
    "Congrats_Description": "Automated precision nourishment is your all-in-one system for perpetual wellness. Let's make getting and staying healthy truly easy for you. Get ready to pick a plan that matches your busy life.",
    "Get_The_Most_Out_Of_Youtopia": "Get the most out of Youtopia",
    "Card1_Title": "How we measure success",
    "Card1_Description": "Most companies goal is profits. Youtopia’s key measure of success is based on each Youtopians’ getting and staying healthy.",
    "Card2_Title": "Precision",
    "Card2_Description": "The more we understand your evolving biology, the better we can align menu items to support your health.",
    "Card3_Title": "Convenience",
    "Card3_Description": "Healthy habits only work when they’re easy. Youtopia daily automates your precision nourishment so you can save lots of time and get healthy the easy way.",
    "Card4_Title": "Let food be your most powerful form of medicine",
    "Card4_Description": "You will get the best results by always consuming optimal daily nutrition at every meal. Progress matters more than perfection."
  },
  "Plan_Selection": {
    "Title": "Welcome to Youtopia",
    "Health_System_That_Adapts_To_You": "A health system that adapts to you",
    "Health_System_That_Adapts_To_You_Description": "Your evolving biology tells us what it needs, we handle the rest. We can do the same for your whole household.",
    "Automated": {
      "Title": "Automated",
      "Description": "Learn how we curate the perfect blend of nutrients for your body and simplicity in your life.",
      "Short_Description": "We make getting and staying healthy easy.",
      "Label": "How it works"
    },
    "Precision": {
      "Title": "Precision",
      "Description": "The more we understand your evolving biology, the better we can align menu items to support your health.",
      "Short_Description": "Explore the levels of precision you believe are essential for you to get and stay healthy",
      "Label": "Make it more precise"
    },
    "Nourishment": {
      "Title": "Nourishment",
      "Description": "Healthy habits only work when they’re easy. Youtopia daily automates your precision nourishment so you can save lots of time and get healthy the easy way.",
      "Short_Description": "Explore the levels of time savings and convenience that meets your needs.",
      "Label": "Make it easier"
    },
    "Start_With_Basic_Plan": "Start with our basic plan or upgrade",
    "Price_Per_Month": "{{price}}/month",
    "Per_Month": "/month",
    "Household_Member_Price": "{{price}}/month for additional household members with the same plan.",
    "Use_This_Plan": "Use This Plan",
    "Plan_Coverage": "Plan Coverage",
    "Back_To_Coverage_Options": "Back to coverage options",
    "Init_Error": "Unable to initialize plan selection. Please try again."
  },
  "Automated": {
    "Title": "Welcome to Youtopia",
    "Automated": "Automated",
    "Automated_Description": "Learn how we curate the perfect blend of nutrients for your body and simplicity in your life.",
    "Nutrient_Tracking": "Automated nutrient tracking",
    "Nutrient_Tracking_Description": "Never track another meal again. Our menu planning resources automatically provide delicious menu items that help you sustain optimal nutrition levels.",
    "Toxins_Removed": "265+ Toxins removed",
    "Toxins_Removed_Description": "Youtopia certified menu items automatically blocks most toxins.",
    "Youtopia_Certified": "Youtopia certified",
    "Youtopia_Certified_Description": "Our certified menu items are all created to optimize the nutrients for your evolving biological needs.",
    "Dining_Opportunities": "Various dining opportunities",
    "Dining_Opportunities_Description": "Take out, delivery or dine-in always optimized for everyone.",
    "Your_Preferences_Embraced": "Your preferences embraced",
    "Your_Preferences_Embraced_Description": "What you do and don’t like remembered and applied every day to future choices.",
    "Never_Track": "Never track another meal",
    "Never_Track_Description": "We calculate it all for you",
    "Always_Ahead": "Always 10 days ahead",
    "Always_Ahead_Description": "We meal plan so you don’t have to",
    "Recommendations": "Recommendations",
    "Recommendations_Description": "Never worry about whats for dinner",
    "Continuous_Refinement": "Continuous refinement",
    "Continuous_Refinement_Description": "Each meal matters, we optimize every single one.",
    "Preferences": "Preferences",
    "Preferences_Description": "What you do and don’t like remembered",
    "Household_Management": "Household Management",
    "Household_Management_Description": "Meet everyones dietary goals and nutritional needs.",
    "Budgeting": "Budgeting",
    "Budgeting_Description": "Track spending and reduce waste.",
    "Right_Sized_Meals": "Right size your meals",
    "Right_Sized_Meals_Description": "Portion sizes personalized to your daily activity levels."
  },
  "Precision": {
    "Title": "Welcome to Youtopia",
    "Precision": "Precision",
    "Precision_Description": "The more we understand your evolving biology, the better we can align menu items to support your health.",
    "Explore_Precision_Options": "Explore the Precision options and select whats best for you.",
    "Essential": "Essential",
    "Essential_Description": "Self-reported insight to identify your biological phenotype.",
    "Essential_Cost_Label": "Included",
    "Essential_Section_1_Title": "1 of 560 Phenotypes",
    "Essential_Section_1_Description": "You take a self-reported survey that will sort you into a unique phenotype category. No judgement - just data.",
    "Essential_Section_2_Title": "Medical history",
    "Essential_Section_2_Description": "Adding your history gives us context to better recommend meals to help you.",
    "Essential_Section_3_Title": "Update anytime",
    "Essential_Section_3_Description": "Your answers will change overtime which can place you in a different phenotype. Change your answers anytime to continue to get the most precise recommendations for your body",
    "Essential_Cost": "Included in basic plan",
    "Thrive": "Thrive",
    "Thrive_Section_1_Title": "Everything in Essential plus more!",
    "Thrive_Section_1_Description": "Get the benefits of phenotype testing along with labs for more precision",
    "Thrive_Section_2_Title": "Frequency of testing",
    "Thrive_Section_2_Description": "We test four times a year so you can see your progress quickly.",
    "Thrive_Section_3_Title": "Where to test",
    "Thrive_Section_3_Description": "There are many options to get your testing from your local hospital to in-home visits to collect what we need.",
    "Thrive_Section_4_Title": "16 Key areas of your body",
    "Thrive_Section_4_Dropdown_1_Title": "Immunity",
    "Thrive_Section_4_Dropdown_1_Description": "It is important to measure the body’s ability to protect itself from getting sick and monitor the body’s ability to overcome viruses and help to eliminate infections. Blood tests can determine if your immune system is responding properly and producing proteins that identify and kill foreign invaders.<br/><br/>Wellness Analysis Includes:<ul><li>Globulin</li><li>Albumin/Globulin Ratio</li><li>Vitamin D</li><li>WBC (White Blood Cells)</li><li>Monocytes</li><li>Lymphocytes</li><li>Neutrophiles</li><li>Eosinophils</li><li>hsCRP</li><li>A1C</li></ul><br/>Youtopia utilizes the following nutrients to help strengthen your immune system:<ul><li>Soluble fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Magnesium</li><li>Vitamin A</li><li>Vitamin B9</li><li>Vitamin B12</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin K</li>",
    "Thrive_Section_4_Dropdown_2_Title": "Heart & Vascular",
    "Thrive_Section_4_Dropdown_2_Description": "Testing cholesterol levels is important for maintaining a healthy heart & vascular system.  Your body needs cholesterol to build healthy cells, but high levels of LDL cholesterol can increase your risk of heart disease.  With high LDL levels, you can develop fatty deposits in your blood vessels. Eventually, these deposits grow, making it difficult for enough blood to flow through your arteries. Youtopia also reviews your heart rate with Heart Rate Variation found in the Discovery Center.  This is important because when the heartbeat is not working properly, just about everything in the body is affected.  Some people never notice the rate or rhythm of their heart.  An abnormal rate or rhythm may be discovered during testing even in healthy people who have no symptoms.<br/><br/>Wellness Analysis Includes:<ul><li>hsCRP</li><li>Hemoglobin A1C</li><li>Uric Acid</li><li>LDL - Bad Cholesterol</li><li>HDL - Good Cholesterol</li><li>Total Cholesterol</li><li>Oxidized LDL Cholesterol</li><li>Triglycerides</li><li>LDL Particle Number</li><li>HDL Particle Number</li><li>Small LDL Particle Number</li><li>LDL Size</li><li>Heart Rate Variation</li></ul><br/>We believe a healthy diet personalized to you that includes the following nutrients can have a positive impact on your heart and vascular health:<ul><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Chromium</li><li>Magnesium</li><li>Iron</li><li>Niacin</li><li>Selenium</li><li>Vitamin B9</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin E</li></ul>",
    "Thrive_Section_4_Dropdown_3_Title": "Prediabetic Indicators",
    "Thrive_Section_4_Dropdown_3_Description": "Blood sugar monitoring is needed to find out if blood glucose levels are within target range.  If glucose gets too low, you can lose the ability to think or function normally.  If it is too high, it can cause damage to the body over the course of time and can lead to diabetes.<br/><br/>Wellness Analysis Includes:<ul><li>Glucose</li><li>Hemoglobin A1C</li><li>Insulin Resistance Marker</li></ul><br/>When managing diabetes and prediabetes, your eating plan is a powerful tool. Youtopia believes a healthy diet, personalized to you that includes the following nutrients, can have a positive impact on glucose metabolism.<ul><li>Complex Carbohydrates</li><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Chromium</li><li>Iron</li><li>Magnesium</li><li>Selenium</li><li>Vitamin B3</li><li>Vitamin B6</li><li>Vitamin B9</li><li>Vitamin D</li><li>Vitamin E</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_4_Title": "Metabolic Syndrome Indicators",
    "Thrive_Section_4_Dropdown_4_Description": "Having metabolic syndrome is a cluster of conditions that occur together, increasing your risk of heart disease, stroke, and type 2 diabetes. These conditions include increased blood pressure, high blood sugar, excess body fat around the waist, and abnormal cholesterol or triglyceride levels.<br/><br/>Wellness Analysis Includes:<ul><li>In-Body Score of Visceral Fat</li><li>A1C</li><li>Blood Pressure</li><li>Glucose</li><li>LDL Bad Cholesterol</li><li>HDL Cholesterol</li><li>Triglycerides</li><li>Waist Circumference</li></ul><br/>Youtopia believes a healthy diet personalized to you can have a positive impact on your health. Youtopia entrees are portion-controlled, a rainbow of colors, and focused on nourishing your body with the following nutrients to support your metabolic health.<ul><li>Soluble Fiber</li><li>Omega 9 Fatty Acid</li><li>Omega 3 Fatty Acid</li><li>Protein</li><li>Choline</li><li>Iodine</li><li>Iron</li><li>Magnesium</li><li>Potassium</li><li>All B Vitamins</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin E</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_5_Title": "Muscles & Metabolism",
    "Thrive_Section_4_Dropdown_5_Description": "Learning your muscle mass can help motivate exercise that supports increasing muscle mass, reduce body fat, improve energy, and reduce stress.<br/><br/>Wellness Analysis Includes:<ul><li>In-Body Muscle Mass</li><li>Tonal Strength Assessment</li></ul><br/>Youtopia entrees are adjusted to improve muscle mass, support muscle growth, and muscle recovery by including adequate protein and the following nutrients in each of your personalized entrée selections.<ul><li>Soluble Fiber</li><li>Calcium</li><li>Magnesium</li><li>Potassium</li><li>Vitamin D</li><li>Vitamin E</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_6_Title": "Body Fats & Angry Fats",
    "Thrive_Section_4_Dropdown_6_Description": "Our body fat is the fat that is located just under the skin.  Visceral Fat (angry fat) is deep within a cavity in the belly.  In surrounds vital organs such as the stomach, liver, and intestines. Knowing the amount of body fat and visceral fat might offer the motivation needed to prevent major health concerns such as high blood pressure and heart attacks.<br/><br/>Wellness Analysis Includes:<ul><li>Body Fat – Measured through InBody</li><li>Angry Fat - Visceral Fat – Measured through InBody</li><li>Waist Circumference</li></ul><br/>Eating Youtopia’s portion-controlled, nutrient dense entrees that include the nutrients below and adding exercise to your daily regime will support weight loss and get visceral fat more in control.<ul><li>Complex carbohydrates</li><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Calcium</li></ul>",
    "Thrive_Section_4_Dropdown_7_Title": "Inflamation",
    "Thrive_Section_4_Dropdown_7_Description": "Chronic inflammatory diseases contribute to more than half of deaths worldwide. Inflammation is associated with diseases such as: autoimmune diseases, cardiovascular, high blood pressure, gastrointestinal disorders, lung disease, mental illnesses, metabolic diseases, neurodegenerative disease, and some types of cancer.<br/><br/>Wellness Analysis Includes:<ul><li>Uric Acid</li><li>Total Protein</li><li>Globulin</li><li>WBC</li><li>Monocytes</li><li>Lymphocytes</li><li>Neutrophiles</li><li>Eosinophils</li><li>Basophils</li><li>hsCRP</li><li>Immature Granulocytes</li><li>Hemoglobin</li><li>Platelets</li></ul><br/>To help you control inflammation markers, Youtopia creates entrees and consumables that are all anti-inflammatory, 100% unprocessed, and contain the following nutrients to support the reduction of inflammation.<ul><li>Soluble fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Calcium</li><li>Magnesium</li><li>Selenium</li><li>Zinc</li><li>Potassium</li><li>Vitamin A</li><li>All B Vitamins</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin E</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_8_Title": "Bone Support",
    "Thrive_Section_4_Dropdown_8_Description": "It’s important to know your body’s bone mass because low bone mass can increase the risk for osteoporosis which affects 10 million people 50 years and over.  Sixteen million men and women have low bone mass putting them at risk for osteoporosis.<br/><br/>Wellness Analysis Includes:<ul><li>Vitamin D</li><li>Calcium</li><li>Magnesium RBC</li><li>Phosphorous</li><li>ALP Alkaline Phosphatase</li><li>Bun/Creatinine Ratio</li><li>hsCRP</li></ul><br/>Youtopia entrees and consumables are focused on the optimum nutrients listed below which are needed to support bone health.<ul><li>Protein</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Soluble Fiber</li><li>Calcium</li><li>Magnesium</li><li>Phosphorus</li><li>Vitamin A</li><li>All B Vitamins</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_9_Title": "Blood Pressure",
    "Thrive_Section_4_Dropdown_9_Description": "It’s important to monitor blood pressure on a regular basis so that you have a clear picture if you are at risk for a heart disease or stroke.<br/><br/>Wellness Analysis Includes:<ul><li>Blood Pressure Valve</li></ul><br/>Youtopia believes healthy nourishment, personalized to you with the following nutrients, can have a positive impact on your health and support decreasing blood pressure.<ul><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Chromium</li><li>Magnesium</li><li>Potassium</li></ul>",
    "Thrive_Section_4_Dropdown_10_Title": "Emotional Impactors",
    "Thrive_Section_4_Dropdown_10_Description": "Research shows that emotional distress creates susceptibility to physical illness.  In addition, emotional stress increases susceptibility to viral infections and stress form lack of control in the workplace or life events creates susceptibility to cardiovascular disease. Depression and anxiety increase the risk for many types of physical health problems, particularly long-lasting conditions like diabetes, heart disease, and stroke. Testing for emotional health can allow for early identification and intervention, leading to better outcomes.<br/><br/>Wellness Analysis Includes:<ul><li>Magnesium RBC</li><li>Glucose</li><li>Ferritin</li><li>Vitamin D</li><li>Vitamin B12</li><li>Folate</li><li>hsCRP</li><li>Heart Rate Variability</li></ul><br/>Youtopia believes that personalizing entrees that utilize the following nutrients can have a positive impact on your emotional impactors.<ul><li>Complex Carbohydrates</li><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Magnesium</li><li>Zinc</li><li>Vitamin A</li><li>All B Vitamins</li><li>Vitamin C</li><li>Vitamin D</li></ul>",
    "Thrive_Section_4_Dropdown_11_Title": "Cellular Energy",
    "Thrive_Section_4_Dropdown_11_Description": "Mitochondrial dysfunction is one of the primary causatives for many pathologies, including neurodegenerative diseases, cancer, metabolic disorders, and aging. Blood tests can identify the overall health of your cells and how those cells are functioning.<br/><br/>Wellness Analysis Includes:<ul><li>Whole Body Phase Angle</li><li>Magnesium RBC</li><li>Calcium</li><li>Phosphorus</li><li>Vitamin B12</li><li>Glucose</li><li>Sodium</li><li>Potassium</li><li>Chloride (Electrolytes)</li><li>CO2</li><li>hsCrp</li><li>MCV</li><li>Hemoglobin</li></ul><br/>Youtopia believes healthy nourishment that is personalized to you and has the following nutrients, can have a positive impact on your cellular health.<ul><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Calcium</li><li>Magnesium</li><li>Phosphorus</li><li>Selenium</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin K</li></ul>",
    "Thrive_Section_4_Dropdown_12_Title": "Digestion",
    "Thrive_Section_4_Dropdown_12_Description": "The tests used for digestion help to identify if the digestive tract is working properly. When the gut is imbalanced, the body cannot absorb nutrients, store fat, and regulate blood sugar.<br/><br/>Wellness Analysis Includes:<ul><li>ALP Alkaline Phosphatase</li><li>Globulin Protein Level</li><li>Total Protein</li><li>Hemoglobin</li></ul><br/>Youtopia entrees are anti-inflammatory to ease internal stress and to help improve digestion so the body can absorb these important digestive nutrients.<ul><li>Complex Carbohydrates</li><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Potassium</li><li>Copper</li><li>Zinc</li><li>Vitamin A</li><li>Vitamin C</li><li>Vitamin D</li><li>Vitamin E</li></ul>",
    "Thrive_Section_4_Dropdown_13_Title": "Liver",
    "Thrive_Section_4_Dropdown_13_Description": "Testing for liver function is used to screen for liver infection, liver disease or damage. The tests measure enzymes that liver cells release in response to damage or disease.<br/><br/>Wellness Analysis Includes:<ul><li>Glucose</li><li>Total Protein</li><li>Albumin</li><li>ALP Alkaline Phosphatase</li><li>SGOT/AST</li><li>SGPT/ALT</li><li>HDL</li><li>Triglycerides</li><li>Total Bilirubin</li><li>Ferritin</li></ul><br/>Youtopia helps to support this powerhouse organ by offering the following important nutrients to each of your personally designed entrée and consumables.<ul><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Calcium</li><li>Copper</li><li>Choline</li><li>Iron</li><li>Magnesium</li><li>Potassium</li><li>Selenium</li><li>Zinc</li><li>Vitamin A</li><li>Vitamin B2</li><li>Vitamin B3</li><li>Vitamin B9</li><li>Vitamin C</li><li>Vitamin E</li></ul>",
    "Thrive_Section_4_Dropdown_14_Title": "Molecular Rusting",
    "Thrive_Section_4_Dropdown_14_Description": "Oxidative stress is an imbalance of free radicals and antioxidants in the body which can lead to cell and tissue damage.  Blood work can access the balance between oxidative damage by free radicals and how well your body can eliminate them.  Recent research suggests that oxidation or molecular rusting may be the major force behind aging and other chronic illnesses.<br/><br/>Wellness Analysis Includes:<ul><li>GGT</li><li>SGOT/AST</li><li>SGOT/ALT</li><li>Albumin/Globulin Ratio</li><li>A1C</li><li>Oxidized LDL</li><li>Sedimentation Rate ESR</li></ul><br/>Youtopia entrees and consumables contain the following important nutrients to support detoxification and perhaps help lower oxidative stress.<ul><li>Soluble Fiber</li><li>Omega 9 Fatty Acids</li><li>Omega 3 Fatty Acids</li><li>Protein</li><li>Calcium</li><li>Copper</li><li>Iron</li><li>Magnesium</li><li>Selenium</li><li>Zinc</li><li>Vitamin A</li><li>Vitamin B2</li><li>Vitamin B3</li><li>Vitamin B6</li><li>Vitamin B9</li><li>Vitamin C</li><li>Vitamin E</li></ul>",
    "Thrive_Section_4_Dropdown_15_Title": "Hydration",
    "Thrive_Section_4_Dropdown_15_Description": "Hydration is important to routinely monitor to prevent dehydration and overhydration.  Numerous critical health problems are associated with poor or excessive hydration such as swelling of the brain and heart failure.<br/><br/>Wellness Analysis Includes:<ul><li>Intracellular Water</li><li>Extracellular Water</li><li>Sodium</li><li>Potassium</li><li>BUN/Creatinine</li><li>eGFR</li></ul>Youtopia encourages you to consume the right amount of water daily.  Youtopia entrees typically provide (when eaten three times a day) 10 to 20% water content to help support your daily hydration intake needs. In addition, all entrees contain the following nutrients to help the absorption of water in the body.<ul><li>Potassium</li><li>Sodium</li><li>Chromium</li><li>Magnesium</li><li>Zinc</li><li>Protein</li></ul>",
    "Thrive_Section_4_Dropdown_16_Title": "Nutritional Lipids",
    "Thrive_Section_4_Dropdown_16_Description": "Hydration is important to routinely monitor to prevent dehydration and overhydration.  Numerous critical health problems are associated with poor or excessive hydration such as swelling of the brain and heart failure.<br/><br/>Wellness Analysis Includes:<ul><li>Intracellular Water</li><li>Extracellular Water</li><li>Sodium</li><li>Potassium</li><li>BUN/Creatinine</li><li>eGFR</li></ul><br/>Youtopia encourages you to consume the right amount of water daily.  Youtopia entrees typically provide (when eaten three times a day) 10 to 20% water content to help support your daily hydration intake needs. In addition, all entrees contain the following nutrients to help the absorption of water in the body.<ul><li>Potassium</li><li>Sodium</li><li>Chromium</li><li>Magnesium</li><li>Zinc</li><li>Protein</li></ul>",
    "Thrive_Cost": "+$103/m",
    "Thrive_Cost_Additional": "$435 One-time cost for labs",
    "Thrive_Description": "Basic wellness assessment covering 16 key areas.",
    "Thrive_Cost_Label": "$$",
    "Flourish": "Flourish",
    "Flourish_Description": "Broader spectrum labs, DNA, and gut health.",
    "Flourish_Cost_Label": "$$$",
    "Flourish_Highlight_Title": "Recommended for best results",
    "Flourish_Highlight_Description": "Flourish gives you more data about your body. The more we know about your unique biology the better your meals will match to it!",
    "Flourish_Section_1_Title": "Everything in Thrive plus more!",
    "Flourish_Section_1_Description": "Get the benefits of labs testing 16 key areas of your body and a broader spectrum of tests for more precision.",
    "Flourish_Section_2_Title": "Frequency of testing",
    "Flourish_Section_2_Description": "We test your DNA once - that normally doesn’t change - and the rest twice a year.",
    "Flourish_Section_3_Title": "Where to test",
    "Flourish_Section_3_Description": "There are many options to get your testing from your local hospital to in-home visits to collect what we need.",
    "Flourish_Dropdown_1_Title": "Vitamin & Mineral Optimizer",
    "Flourish_Dropdown_1_Subtitle": "Labs for vitamin and minerals",
    "Flourish_Dropdown_1_Description": "TBD",
    "Flourish_Dropdown_2_Title": "Toxin Eliminator",
    "Flourish_Dropdown_2_Subtitle": "Labs for toxins and heavy metals",
    "Flourish_Dropdown_2_Description": "TBD",
    "Flourish_Dropdown_3_Title": "Genetic Optimizer",
    "Flourish_Dropdown_3_Subtitle": "Labs to see what you inherited ",
    "Flourish_Dropdown_3_Description": "TBD",
    "Flourish_Dropdown_4_Title": "Food Processor",
    "Flourish_Dropdown_4_Subtitle": "Labs for microbiome and gut health",
    "Flourish_Dropdown_4_Description": "TBD",
    "Flourish_Cost": "+$207/m",
    "Flourish_Cost_Additional": "$747 One-time cost for labs",
    "Select_Plan": "Select Plan"
  },
  "Nourishment": {
    "Title": "Welcome to Youtopia",
    "Nourishment": "Nourishment",
    "Nourishment_Description": "Healthy habits only work when they’re easy. Youtopia daily automates your precision nourishment so you can save lots of time and get healthy the easy way.",
    "Explore_Nourishment_Options": "Explore the Nourishment options and select whats best for you.",
    "Get_Dietary_Restrictions_Options_Error": "Failed to Load Allergens and Intolerances Options",
    "Minimal": "Minimal",
    "Minimal_Description": "Make recipes at home that are optimized for health.",
    "Minimal_Cost_Label": "Included",
    "Minimal_Coming_Soon": "Coming soon! Enjoy [incentive] until we launch Minimal in 2027.",
    "Boost": "Boost",
    "Boost_Description": "Enjoy the convenience of readily available chef-made meals when you don’t want to cook for yourself.",
    "Boost_Cost_Label": "$$",
    "Boost_Note": "#% off ordered meals",
    "Accelerate": "Accelerate",
    "Accelerate_Description": "Fully optimized nutrition with all chef made meals.",
    "Accelerate_Cost_Label": "$$$",
    "Accelerate_Note": "#% off ordered meals",
    "Minimal_Section_1_Title": "12+ menu items/week",
    "Minimal_Section_1_Description": "You’re taking the first step and that’s everything. Minimalistic keeps it simple so healthy eating fits into your life without demanding more of it. No overhaul, no pressure. Just a quiet but meaningful shift in the right direction.",
    "Minimal_Section_2_Title": "10% off Dine Out, Delivery, or Pickup",
    "Minimal_Section_2_Description": "We understand the importance of going out with friends and family. Enjoy eating out, in, or on the go.",
    "Minimal_Section_3_Title": "15% off Schedule Ahead and Save",
    "Minimal_Section_3_Description": "Planning meals 4 days ahead makes the healthy choice the easy choice. Schedule meals early and enjoy both better health and savings.",
    "Minimal_Section_4_Title": "Grocery app integration",
    "Minimal_Section_4_Description": "Connect with Instacart to make shopping for meals and eating healthy that much easier.",
    "Minimal_Cost": "Included in basic plan",
    "Minimal_Cost_Additional": "Doesn’t include menu items",
    "Boost_Section_1_Title": "Everything in Minimal plus more!",
    "Boost_Section_1_Description": "Cook and build recipes yourself or enjoy chef-made menu items.",
    "Boost_Section_2_Title": "Time and effort",
    "Boost_Section_2_Description": "Spend less time cooking and more time doing what you love with meals delivered to your door.",
    "Boost_Section_3_Title": "Schedule and save",
    "Boost_Section_3_Description": "Planning meals ahead makes the healthy choice the easy choice. Schedule meals early and enjoy both better health and savings.",
    "Boost_Section_4_Title": "#% off all restaurant meals",
    "Boost_Section_4_Description": "People usually save ~$# per month on food.",
    "Boost_Cost": "+$122/m",
    "Boost_Cost_Additional": "Doesn’t include meals",
    "Accelerate_Highlight_Title": "Recommended for best results",
    "Accelerate_Highlight_Description": "Make the healthy choice the easy choice. No cooking or grocery shopping required.",
    "Accelerate_Section_1_Title": "Everything in Boost plus more!",
    "Accelerate_Section_1_Description": "Enjoy chef-made menu items or cook and build recipes yourself",
    "Accelerate_Section_2_Title": "Time and effort",
    "Accelerate_Section_2_Description": "Never worry about making dinner again. Cook only when you want to.",
    "Accelerate_Section_3_Title": "Schedule and save",
    "Accelerate_Section_3_Description": "Planning meals ahead makes the healthy choice the easy choice. Schedule meals early and enjoy both better health and savings.",
    "Accelerate_Section_4_Title": "#% off all restaurant meals",
    "Accelerate_Section_4_Description": "People usually save ~$# per month on food.",
    "Accelerate_Cost": "+$182/m",
    "Accelerate_Cost_Additional": "Doesn’t include meals",
    "Select_Plan": "Select Plan"
  },
  "Package_Options": {
    "Automated": "Automated",
    "Essential": "Essential",
    "Thrive": "Thrive",
    "Flourish": "Flourish",
    "Minimal": "Minimal",
    "Boost": "Boost",
    "Accelerate": "Accelerate"
  },
  "Add_Members": {
    "Title": "Welcome to Youtopia",
    "Who_Else_Would_Benefit": "Who else at home would benefit?",
    "Who_Else_Would_Benefit_Description": "Add anyone in your household (at your same address) to personalize things for. You can update this later.",
    "Savings_With_Additional_Plans": "Savings With Additional Plans",
    "Add_Person": "Add Person",
    "Add_Another_Person": "Add Another Person",
    "Personal_Information": "Personal Information",
    "Guardian_Information": "Guardian Information",
    "Permissions_And_Data_Sharing": "Permissions And Data Sharing",
    "Permissions_Unavailable": "Permissions can’t be loaded right now. You can invite them and set permissions later from their profile.",
    "Plan_Coverage": "Plan Coverage",
    "Legal_First_Name": "Legal First Name",
    "Legal_Last_Name": "Legal Last Name",
    "Date_Of_Birth": "Date Of Birth",
    "Invite_Email": "Invite Email",
    "Are_You_Legal_Guardian": "Are you a legal guardian of this person?",
    "Has_Smart_Device": "Will they access the app?",
    "Has_Smart_Device_Description": "Email will be added on the next step.",
    "Additional_Legal_Guardian": "Who else is their legal guardian?",
    "Additional_Legal_Guardian_Description": "You are their guardian either way. Pick someone else in your household to share it with.",
    "Additional_Legal_Guardian_None": "Just me",
    "Order_For_Household": "Order for Household",
    "Order_For_Household_Description": "This member can place food orders on behalf of everyone.",
    "Share_Health_Information": "Share my health & nutrition information",
    "Share_Health_Information_Description": "This household member will be able to view your health and nutrient profile information.",
    "Access_Health_Information": "Access health & nutrition data",
    "Access_Health_Information_Description": "You’ll be able to view this household member’s health and nutrition profile after they choose to share it.",
    "Plan_Coverage_Description": "Everyone is different - our plans reflect that.",
    "Back_To_Coverage_Options": "Back to coverage options",
    "Information": "Information",
    "Guardian": "Guardian",
    "Permissions": "Permissions",
    "Im_Covering_Their_Plan": "I’m covering their plan",
    "Not_Persons_Guardian": "I am not this persons guardian",
    "Am_Persons_Guardian": "I am this persons guardian",
    "Can": "Can",
    "Cannot": "Cannot",
    "Remove_Person": "Remove Person",
    "Remove_Person_Description": "Are you sure you want to remove {{name}}? This action cannot be undone.",
    "Account_Exists_Title": "Uh Oh",
    "Account_Exists_Message_Start": "The email you entered",
    "Account_Exists_Message_End": "is already tied to an account and cannot be added to your household.",
    "Account_Exists_Support": "Email us to get help at",
    "Add_Someone_Else": "Add Someone Else"
  },
  "Help": {
    "Title": "Help",
    "Version": "Version",
    "Get_Help": "Get help",
    "Contact_Support": "Contact support",
    "Rate_App": "Rate the app",
    "View_In_Store": "View in the app store",
    "Legal": "Legal",
    "Terms_Of_Service": "Terms of Service",
    "Privacy_Policy": "Privacy Policy",
    "About": "About",
    "Build": "Build",
    "Environment": "Environment"
  },
  "Invitation_Error": {
    "Back_To_Sign_In": "Back to sign in"
  },
  "Error_Page": {
    "Uh_Oh": "Uh oh",
    "Email_Mismatch_Title": "The email you entered doesn't match the invite",
    "Email_Mismatch_Use_Correct_Email": "Use the email the invite was sent to",
    "Email_Mismatch_Contact_Inviter": "Contact {{name}} and have them update your email address",
    "Email_Mismatch_Email_Support": "Email us to get help"
  },
  "Permission": {
    "Get_Scopes_Error": "Unable to load permissions. Please try again.",
    "Get_Permissions_Error": "Unable to load your permissions. Please try again.",
    "Grant_Permission_Error": "Failed to update permissions",
    "Revoke_Permission_Error": "Failed to update permissions",
    "Create_Orders_Disabled": "You don't have permission to create orders",
    "No_Permission": "You do not have permission"
  },
  "Permission_Sheet": {
    "Title": "Permissions",
    "Order_For_Household": "Order for Household",
    "Order_For_Household_Description": "This member can place food orders on behalf of everyone.",
    "Manage_Order_Guests": "Manage Order Guests",
    "Manage_Order_Guests_Description": "They can add guests to household orders and order for them.",
    "Buy_Memberships": "Buy Memberships",
    "Buy_Memberships_Description": "They can buy memberships, which the household pays for.",
    "You_Have_Permission_To": "{{name}} has permission to",
    "Order_For_Household_Self": "Place food orders on behalf of everyone.",
    "Close": "Close",
    "Save": "Save",
    "Next": "Next",
    "Reconciliation_Failed": "Some changes were saved, but we could not confirm what is set now. Close and reopen this to see the current permissions.",
    "You_Cannot": "{{name}} does not have permission to",
    "Owner_Keeps_Everything": "The household owner keeps every permission.",
    "Comes_With_Role": "Only available with a role that includes it.",
    "Catalog_Unavailable": "Permissions can’t be changed right now. Try again in a moment.",
    "Withheld_By_A_Broader_Rule": "Covered by a broader rule that turns this off."
  },
  "Data_Privacy": {
    "Title": "Is my data kept private?",
    "Modal_Title": "It’s Your Data, and We Keep It Private",
    "Modal_Description": "All data collected is for the sole purpose of fine-tuning and personalizing your Youtopia experience and will not be shared with any non-authorized third parties.<br/><br/>We do not sell your data or provide it to other parties for tracking or marketing purposes.<br/><br/>Read our Privacy Policy."
  },
  "Closed_Banner": {
    "Closed": "Closed",
    "Opens": "Opens",
    "Schedule_Order_Message": "{{name}} is closed right now but you can schedule an order for later.",
    "Today": "Today",
    "Tomorrow": "Tomorrow",
    "Sun": "Sun",
    "Mon": "Mon",
    "Tue": "Tue",
    "Wed": "Wed",
    "Thu": "Thu",
    "Fri": "Fri",
    "Sat": "Sat"
  }
}
